import { Component, Input, OnInit } from '@angular/core'
import { HyperService } from '../../services/hyper/hyper.service'
import { TracingService } from '../../services/tracing/tracing.service'

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class IconComponent implements OnInit {
  @Input() name: string

  @Input() color = 'hotpink'

  @Input() fill = 'red'

  public icons: any = {
    sortAlphaAsc: {
      paths: [
        {
          d: 'M19 17H22L18 21L14 17H17V3H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z',
        },
      ],
    },
    sortAlphaDesc: {
      paths: [
        {
          d: 'M19 7H22L18 3L14 7H17V21H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z',
        },
      ],
    },
    sortNumericAsc: {
      paths: [
        {
          d: 'M19 17H22L18 21L14 17H17V3H19V17M9 13H7C5.9 13 5 13.9 5 15V16C5 17.11 5.9 18 7 18H9V19H5V21H9C10.11 21 11 20.11 11 19V15C11 13.9 10.11 13 9 13M9 16H7V15H9V16M9 3H7C5.9 3 5 3.9 5 5V9C5 10.11 5.9 11 7 11H9C10.11 11 11 10.11 11 9V5C11 3.9 10.11 3 9 3M9 9H7V5H9V9Z',
        },
      ],
    },
    sortNumericDesc: {
      paths: [
        {
          d: 'M19 7H22L18 3L14 7H17V21H19M9 21H5V19H9V18H7C5.9 18 5 17.11 5 16V15C5 13.9 5.9 13 7 13H9C10.11 13 11 13.9 11 15V19C11 20.11 10.11 21 9 21M9 15H7V16H9M7 3H9C10.11 3 11 3.9 11 5V9C11 10.11 10.11 11 9 11H7C5.9 11 5 10.11 5 9V5C5 3.9 5.9 3 7 3M7 9H9V5H7Z',
        },
      ],
    },
    batteryPlus: {
      paths: [
        {
          d: 'M16,4h-2V2h-4v2H8C7.45,4,7,4.45,7,5v16c0,0.55,0.45,1,1,1h8c0.55,0,1-0.45,1-1V5C17,4.45,16.55,4,16,4z M15,14h-2v2h-2 v-2H9v-2h2v-2h2v2h2V14z',
        },
      ],
    },
    batteryBolt: {
      paths: [
        {
          d: 'M16.67,4H15V2H9V4H7.33A1.33,1.33,0,0,0,6,5.33V20.66A1.338,1.338,0,0,0,7.33,22h9.33A1.338,1.338,0,0,0,18,20.67V5.33A1.336,1.336,0,0,0,16.67,4M11,20V14.5H9L13,7v5.5h2',
        },
      ],
    },
    home: {
      paths: [{ d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' }],
    },
    warning: {
      paths: [
        {
          d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
        },
      ],
    },
    triangleWarning: {
      paths: [
        // {
        //   d: 'M0,0H24V24H0Z',
        // },
        {
          d: 'M1,21H23L12,2Zm12-3H11V16h2Zm0-4H11V10h2Z',
        },
      ],
    },
    cloudRound: {
      paths: [
        {
          d: `M4.7353,15.6324 L5.8529,15.6324 L6.9706,15.6324 L6.9706,14.5147 L5.8529,14.5147 L4.7353,14.5147
          L3.6176,14.5147 L2.5,14.5147 L2.5,15.6324 L3.6176,15.6324 z`,
        },
        {
          d: `M5.8529,13.3971 L6.9706,13.397 L8.0882,13.397 L8.0882,12.2794 L6.9706,12.2794 L5.8529,12.2794
        L4.7353,12.2794 L3.6176,12.2794 L3.6176,13.3971 L4.7353,13.3971 z`,
        },
        {
          d: `M18.1471,11.1617h-0.0277c-0.2813-2.8199-2.6678-5.0294-5.5605-5.0294c-2.8928,0-5.2791,2.2094-5.5604,5.0294
        h1.1247C8.399,8.9594,10.283,7.25,12.5588,7.25c2.4651,0,4.4706,2.0055,4.4706,4.4706v0.5588h1.1176
        c1.2325,0,2.2353,1.0027,2.2353,2.2353c0,1.2325-1.0027,2.2353-2.2353,2.2353H6.9706H5.8529H4.7353H3.6176v1.1176h1.1176h1.1176
        h1.1176h11.1765c1.8488,0,3.3529-1.5042,3.3529-3.3529C21.5,12.6659,19.9959,11.1617,18.1471,11.1617z`,
        },
      ],
    },
    cart: {
      paths: [
        {
          d: `M19.601,5.0392h-10.4l0.238,1.354h9.923l-0.98,5.555h-1.78v-1.227v-1.353v-0.001v-1.353h-1.354v1.353v0.001
          v1.353v1.227h-1.143v-1.227v-1.353v-0.001v-1.353h-1.354v1.353v0.001v1.353v1.227h-1.143v-1.227v-1.353v-0.001v-1.353H10.254v1.353
          v0.001v1.353v1.227H8.742l-0.979-5.56l-0.237-1.349l-0.047-0.267c-0.1375-0.7831-0.8179-1.3543-1.613-1.354h-2.84v1.354h3.077
          l0.047,0.267l0.239,1.354l0.979,5.555l0.239,1.354l0.19,1.078c0.1383,0.7831,0.8188,1.3539,1.614,1.354h9.679l0.238-1.354H9.171
          l-0.19-1.078h9.162c0.7952,0.0003,1.4755-0.5708,1.613-1.354l0.98-5.555l0.238-1.354H19.601z`,
        },
        {
          d: `M9.606,16.8132c-0.3123-0.1899-0.6705-0.2913-1.036-0.293c-0.1286,0.0006-0.2568,0.0134-0.383,0.038
          c-0.9554,0.1835-1.6463,1.0191-1.647,1.992c0,1.1214,0.9091,2.0305,2.0305,2.0305s2.0305-0.9091,2.0305-2.0305
          C10.5995,17.8361,10.2213,17.1758,9.606,16.8132z M8.648,19.2083c-0.0272,0.0078-0.0549,0.0134-0.083,0.017
          c-0.3739,0-0.677-0.3031-0.677-0.677c0.0026-0.3136,0.2231-0.5832,0.53-0.6479c0.3308-0.1077,0.6863,0.0733,0.7939,0.4042
          c0.0256,0.0786,0.0355,0.1614,0.0291,0.2438C9.2382,18.8864,8.9839,19.1694,8.648,19.2083z`,
        },
        {
          d: `M18.932,16.6332c-1.0578-0.3579-2.2055,0.2095-2.5634,1.2673c-0.0709,0.2096-0.1069,0.4294-0.1066,0.6506
          c0,1.1215,0.9091,2.0305,2.0305,2.0305c1.1215,0,2.0305-0.9091,2.0305-2.0305C20.3214,17.6788,19.7607,16.9058,18.932,16.6332z
           M18.292,19.2282c-0.3739,0-0.677-0.3031-0.677-0.677c0-0.3738,0.3031-0.677,0.677-0.677c0.3668,0.0167,0.6603,0.3102,0.677,0.677
          C18.9452,18.9148,18.6556,19.2044,18.292,19.2282z`,
        },
      ],
    },
    emma: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: `M12.634,5.5798v-1.243c-0.212-0.014-0.42-0.027-0.633-0.027c-5.2467,0-9.5,4.2533-9.5,9.5v3.344
          c0,0.6992,0.5668,1.266,1.2661,1.266h6.4399c0.348,0.99,1.4326,1.5104,2.4225,1.1625c0.5438-0.1911,0.9714-0.6187,1.1625-1.1625
          h6.441c0.6967-0.0005,1.2622-0.5634,1.2661-1.26v-3.8l-1.267,0.002v3.8h-6.443c-0.0486-0.1354-0.1123-0.2649-0.19-0.386l3.591-3.6
          c0.2063-0.204,0.2476-0.5222,0.1-0.772c-0.119-0.1942-0.3312-0.3116-0.559-0.309h-1.932l2.9-2.9v1.636h1.2661l0.007-3.8l-3.8-0.007
          v1.266h1.639l-3.982,3.982c-0.2068,0.2042-0.248,0.5229-0.1,0.773c0.1188,0.1943,0.3312,0.3118,0.559,0.309h1.933l-2.625,2.635
          c-0.9785-0.3208-2.0344,0.1963-2.381,1.166H3.77v-2.527h1.262h1.267h1.267v-1.267H6.299H5.032H3.7936
          c0.1025-1.7618,0.7541-3.4443,1.8727-4.8026L6.563,9.4547l0.8961,0.896L7.459,10.3508l0.8959,0.8959l0.8959-0.8959L7.463,8.5548
          L7.463,8.5547L7.4354,8.5272l-0.007-0.007H7.4283l-0.875-0.874c1.3353-1.1862,3.022-1.911,4.8116-2.0449v1.3635v1.33v1.267h1.267
          v-1.267v-1.33v-1.384 M11.999,18.4287c-0.3502,0-0.634-0.2838-0.634-0.634s0.2839-0.634,0.634-0.634
          c0.3501,0,0.634,0.2838,0.634,0.634S12.3491,18.4287,11.999,18.4287z`,
        },
      ],
      /* paths: [
        {
          d: 'M12,20.84a2.82,2.82,0,0,1-1.36-.33l-5.27-3A2.9,2.9,0,0,1,4,15.13v-6A2.89,2.89,0,0,1,5.41,6.77l5.27-3a2.93,2.93,0,0,1,2.73,0l5.26,3A2.86,2.86,0,0,1,20,9.13v6a2.88,2.88,0,0,1-1.37,2.37h0l-5.26,3A2.86,2.86,0,0,1,12,20.84ZM12,5.43a.82.82,0,0,0-.37.07l-5.26,3A.92.92,0,0,0,6,9.13v6a.92.92,0,0,0,.37.63l5.26,3a1,1,0,0,0,.74,0l5.27-3a.94.94,0,0,0,.36-.63v-6a.94.94,0,0,0-.36-.62l-5.27-3A.76.76,0,0,0,12,5.43Zm6.13,11.2h0Z',
        },
        {
          d: 'M12,16.84a2.82,2.82,0,0,1-1.36-.33l-1.77-1a2.9,2.9,0,0,1-1.37-2.37v-2A2.89,2.89,0,0,1,8.91,8.77l1.77-1a2.93,2.93,0,0,1,2.73,0l1.76,1a1.51,1.51,0,0,1,0,2.73L12.54,13a1,1,0,1,1-1-1.73l2-1.14L12.41,9.5a1,1,0,0,0-.74,0l-1.76,1a.92.92,0,0,0-.37.62v2a.92.92,0,0,0,.37.63l1.76,1a1,1,0,0,0,.74,0l2.64-1.5A1,1,0,1,1,16,15l-2.63,1.51A2.86,2.86,0,0,1,12,16.84Z',
        }
      ] */
    },
    charging: {
      viewBox: '0 0 123.38 114.96',
      paths: [
        {
          d: `M41.49,50.31h7.25V35.72c0-2.07,1.69-3.76,3.76-3.76l0,0c2.07,0,3.76,1.69,3.76,3.76v14.59h11.05V35.72 c0-2.07,1.69-3.76,3.76-3.76l0,0c2.07,0,3.76,1.69,3.76,3.76v14.59h7.06c1.31,0,2.38,1.07,2.38,2.38v2.76 c0,1.31-1.07,2.38-2.38,2.38h-40.4c-1.31,0-2.38-1.07-2.38-2.38v-2.76C39.11,51.38,40.18,50.31,41.49,50.31L41.49,50.31z M51.86,59.96h20.04v2.98H51.86V59.96L51.86,59.96z M34.12,106.63c2.05,1.26,2.69,3.95,1.43,6c-1.26,2.05-3.95,2.69-6,1.43 c-8.93-5.49-16.36-13.23-21.51-22.43c-4.96-8.87-7.79-19.09-7.79-29.94c0-16.97,6.88-32.33,18-43.44c11.12-11.12,26.48-18,43.44-18 c16.97,0,32.35,6.81,43.48,17.86c11.1,11.03,17.96,26.28,17.96,43.21c0,21.97-12.27,37.39-26.04,44.32 c-5.09,2.57-10.43,3.98-15.48,4.17c-5.28,0.19-10.28-0.97-14.42-3.58c-7.25-4.57-11.72-13.27-10.35-26.52 c-9.37-1.49-13.48-6.43-13.48-16.09l0-5.76h37.06v5.19c0,9.78-4.59,15.77-14.77,16.75l-0.05,0c-1.21,9.93,1.55,16.12,6.22,19.06 c2.62,1.65,5.91,2.38,9.47,2.25c3.8-0.14,7.89-1.24,11.87-3.24c11.23-5.65,21.23-18.34,21.23-36.55c0-14.53-5.87-27.6-15.37-37.04 C89.49,14.81,76.29,8.98,61.69,8.98c-14.56,0-27.73,5.9-37.27,15.44C14.88,33.96,8.98,47.13,8.98,61.69 c0,9.35,2.42,18.12,6.67,25.71C20.05,95.27,26.43,101.9,34.12,106.63L34.12,106.63z`,
        },
      ],
    },
    eCharging: {
      viewBox: '0 0 48 48',
      paths: [
        {
          d: `M33,22v3v3v9c0,1.379-1.121,2.5-2.5,2.5H29V7V6c0-1.105-0.895-2-2-2h-1h-2V2H13v2h-3C8.895,4,8,4.895,8,6v1h18 v36H11V20v-3v-3v-3H8v3v3v3v23v1c0,1.105,0.895,2,2,2h1h15h1c1.105,0,2-0.895,2-2v-1v-0.5h1.5c3.032,0,5.5-2.468,5.5-5.5v-9v-3v-3 v-3h-3V22z`,
        },
        {
          d: 'M40,14 L40,26 L43,26 L43,14 z',
        },
      ],
      polygon: '13.5,27.167 16.833,27.167 16.833,36.333 23.5,23.833 20.167,23.833 20.167,14.667 ',
    },
    reset: {
      paths: [{ d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' }],
    },
    filter: {
      paths: [{ d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' }],
    },
    filterV2: {
      paths: [
        {
          d: 'M 14.117188 12.5 L 14.117188 23.445312 C 14.148438 23.65625 14.128906 23.871094 14.054688 24.070312 C 13.984375 24.269531 13.867188 24.449219 13.710938 24.597656 C 13.445312 24.855469 13.085938 25 12.714844 25 C 12.339844 25 11.984375 24.855469 11.71875 24.597656 L 8.882812 21.804688 C 8.726562 21.65625 8.609375 21.476562 8.539062 21.277344 C 8.46875 21.078125 8.445312 20.863281 8.472656 20.652344 L 8.472656 12.5 L 8.429688 12.5 L 0.296875 2.25 C 0.0703125 1.960938 -0.0351562 1.59375 0.0117188 1.230469 C 0.0546875 0.863281 0.246094 0.53125 0.539062 0.304688 C 0.789062 0.113281 1.09375 0.0078125 1.414062 0 L 21.179688 0 C 21.496094 0.0078125 21.800781 0.113281 22.054688 0.304688 C 22.347656 0.53125 22.535156 0.863281 22.582031 1.230469 C 22.625 1.59375 22.523438 1.960938 22.292969 2.25 L 14.160156 12.5 Z M 14.117188 12.5',
        },
      ],
    },
    person: {
      paths: [
        {
          d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
        },
      ],
    },
    personOutline: {
      paths: [
        {
          d: `M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z`,
        },
      ],
    },
    edit: {
      paths: [
        {
          d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
        },
      ],
    },
    star: {
      paths: [
        {
          d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
        },
      ],
    },
    profinet: {
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M22,12.57v-1.14h-9.43v-2h2.86V9.14V8.29v-4V3.71V3.14H8.57v0.57v0.57v4v0.86v0.29h2.86v2H2v1.14h2.86v2H2v0.57v0.57v4v0.86 v0.29h6.86v-0.29v-0.86v-4v-0.57v-0.57H6v-2h12v2h-2.86v0.57v0.57v4v0.86v0.29H22v-0.29v-0.86v-4v-0.57v-0.57h-2.86v-2H22z M9.71,8.29v-4h4.57v4H9.71z M7.71,15.71v4H3.14v-4H7.71z M20.86,15.71v4h-4.57v-4H20.86z',
        },
      ],
    },
    impulseAnalytics: {
      paths: [
        {
          d: `M20.143,12c-0.2263-0.0004-0.4379,0.1121-0.564,0.3l-0.793,1.189L17.993,12.3
          c-0.1263-0.1882-0.3383-0.3007-0.565-0.3h-1.356V3.857c0-0.7495-0.6075-1.357-1.357-1.357H9.285v1.357h5.429v16.286H9.285v-6.786
          h1.358H12h1.357V12H12h-1.357H9.285v-1.357h1.358H12h1.357V9.286H12h-1.357H9.285V7.928h1.358H12h1.357V6.571H12h-1.357H9.285
          c-0.7495,0-1.357,0.6075-1.357,1.357V12H7.061l-1.2-3.608C5.7413,8.0366,5.3562,7.8455,5.0008,7.9651
          C4.7997,8.0329,4.6417,8.1908,4.574,8.392L3.368,12H2.5v1.357h1.357c0.2917-0.0005,0.5506-0.1873,0.643-0.464l0.714-2.14l0.713,2.14
          c0.0925,0.2771,0.3519,0.4639,0.644,0.464h1.357v6.786c0,0.7495,0.6075,1.357,1.357,1.357h5.429c0.7495,0,1.357-0.6075,1.357-1.357
          v-6.786h0.994l1.156,1.733c0.2074,0.3118,0.6282,0.3964,0.94,0.189c0.075-0.0498,0.1392-0.114,0.189-0.189l1.156-1.733H21.5V12
          H20.143z`,
        },
      ],
    },
    cancel: {
      path: `M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z`,
    },
    ocppProxy: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: `M21.5,13.5H20h-1.5H18l-2-1.8c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0h-4.1v-1.2h1.3
          c0.3,0,0.5-0.1,0.7-0.4l2.1-3.7v0H17h1.5H20V4.7h-1.5H17h-1.5h-0.4c-0.3,0-0.5,0.1-0.7,0.4l-2.1,3.7h-0.8V5.5
          c0-0.4-0.3-0.8-0.8-0.8h-0.5V4h-5v0.7H4.8C4.3,4.7,4,5.1,4,5.5v5.8H1v1.5h3v6.5C4,19.7,4.3,20,4.8,20h6c0.4,0,0.8-0.3,0.8-0.8
          v-3.6h1.3l3.3,3.1c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0H17h1.5H20h1.5v-1.5H20h-1.5H17h0l-3.3-3.1
          c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0h-1.6V13h3.8l2,1.8c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.1
          c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0h0.8H20h1.5H23v-1.5H21.5z M10,18.5H5.5V6.2H10V18.5z`,
        },
      ],
      polygon: '7.2,16.2 9.5,11.8 8.3,11.8 8.3,8.5 6,13 7.2,13',
    },
    mGuard: {
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M14.53,9.14c0-0.24-0.05-0.41-0.14-0.53c-0.14-0.18-0.3-0.27-0.5-0.27c-0.24,0-0.43,0.09-0.57,0.26 c-0.14,0.17-0.22,0.45-0.22,0.83v2.72h1.17h0.26V9.14z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M11.07,9.24c0-0.23-0.01-0.39-0.04-0.47c-0.04-0.13-0.12-0.24-0.22-0.32c-0.11-0.08-0.23-0.12-0.37-0.12 c-0.23,0-0.42,0.09-0.57,0.26C9.71,8.76,9.64,9.05,9.64,9.45v2.69h1.43V9.24z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M21.14,10.86c-0.43,0-0.79,0.32-0.85,0.73c0,0-0.01,0-0.01,0h-2.01V9.82V7.7V7.57c0-1.28-1.04-2.32-2.32-2.32h-1.68h-1.56 H5.74v2.33H3.73c0,0-0.01,0-0.01,0C3.65,7.16,3.3,6.85,2.86,6.85C2.39,6.85,2,7.24,2,7.71s0.39,0.87,0.87,0.87 c0.43,0,0.79-0.32,0.85-0.73c0,0,0.01,0,0.01,0h2.01v2.21H4.7c0,0-0.01,0-0.01,0C4.62,9.66,4.26,9.34,3.83,9.34 c-0.48,0-0.87,0.39-0.87,0.87s0.39,0.87,0.87,0.87c0.43,0,0.79-0.32,0.85-0.73c0,0,0.01,0,0.01,0h1.04v1.79h1.88V6.87H9.5v0.77 c0.27-0.32,0.55-0.55,0.82-0.68c0.28-0.14,0.61-0.2,1-0.2c0.42,0,0.75,0.07,1,0.22c0.24,0.15,0.45,0.37,0.6,0.66 c0.32-0.34,0.61-0.58,0.87-0.7c0.26-0.12,0.58-0.19,0.97-0.19c0.56,0,1.01,0.17,1.32,0.5c0.32,0.34,0.48,0.86,0.48,1.57v3.31h1.71 v-0.27h2.01c0,0,0.01,0,0.01,0c0.07,0.41,0.42,0.73,0.85,0.73c0.48,0,0.87-0.39,0.87-0.87S21.61,10.86,21.14,10.86z M2.86,8.3 c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.26-0.59,0.59-0.59c0.32,0,0.59,0.26,0.59,0.59C3.45,8.04,3.19,8.3,2.86,8.3z M3.83,10.79 c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.26-0.59,0.59-0.59c0.32,0,0.59,0.26,0.59,0.59C4.42,10.53,4.16,10.79,3.83,10.79z M21.14,12.32c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.26-0.59,0.59-0.59c0.32,0,0.59,0.26,0.59,0.59 C21.72,12.05,21.46,12.32,21.14,12.32z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M19.89,13.15c-0.43,0-0.79,0.32-0.85,0.73c0,0-0.01,0-0.01,0h-0.76v-1.31h-1.14h-0.74h-2.02h-1.43H10.9H9.73H9.47H7.45 H6.87H5.74v2.32h1.56v2.15c0,0,0,0.01,0,0.01c-0.41,0.07-0.73,0.42-0.73,0.85c0,0.48,0.39,0.87,0.87,0.87 c0.48,0,0.87-0.39,0.87-0.87c0-0.43-0.32-0.79-0.73-0.85c0,0,0-0.01,0-0.01v-2.15h1.66v0.76c0,0,0,0.01,0,0.01 c-0.41,0.07-0.73,0.42-0.73,0.85c0,0.48,0.39,0.87,0.87,0.87c0.48,0,0.87-0.39,0.87-0.87c0-0.43-0.32-0.79-0.73-0.85 c0,0,0-0.01,0-0.01v-0.76h8.75v-0.73h0.76c0,0,0.01,0,0.01,0c0.07,0.41,0.42,0.73,0.85,0.73c0.48,0,0.87-0.39,0.87-0.87 C20.75,13.53,20.37,13.15,19.89,13.15z M8.02,17.89c0,0.32-0.26,0.59-0.59,0.59c-0.32,0-0.59-0.26-0.59-0.59 c0-0.32,0.26-0.59,0.59-0.59C7.76,17.3,8.02,17.56,8.02,17.89z M9.96,16.5c0,0.32-0.26,0.59-0.59,0.59c-0.32,0-0.59-0.26-0.59-0.59 c0-0.32,0.26-0.59,0.59-0.59C9.69,15.91,9.96,16.18,9.96,16.5z M19.89,14.6c-0.32,0-0.59-0.26-0.59-0.59 c0-0.32,0.26-0.59,0.59-0.59c0.32,0,0.59,0.26,0.59,0.59C20.48,14.34,20.21,14.6,19.89,14.6z',
        },
      ],
    },
    arrowTopLeft: {
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M14.12,8.46L19.78,14.12L14.12,19.78L8.46,14.12L4.22,18.36V4.22H18.36L14.12,8.46M6.34,13.41L8.46,11.29L14.12,16.95L16.95,14.12L11.29,8.47L13.41,6.34H6.34V13.41Z',
        },
      ],
    },
    arrowBottomRight: {
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M9.88,15.54L4.22,9.88L9.88,4.22L15.54,9.88L19.78,5.64V19.78H5.64L9.88,15.54M17.66,10.59L15.54,12.71L9.88,7.05L7.05,9.88L12.71,15.54L10.59,17.66H17.66V10.59Z',
        },
      ],
    },
    pipe: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M22,14H20V16H14V13H16V11H14V6A2,2 0 0,0 12,4H4V2H2V10H4V8H10V11H8V13H10V18A2,2 0 0,0 12,20H20V22H22',
        },
      ],
    },
    functionSymbol: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M15.6,5.29C14.5,5.19 13.53,6 13.43,7.11L13.18,10H16V12H13L12.56,17.07C12.37,19.27 10.43,20.9 8.23,20.7C6.92,20.59 5.82,19.86 5.17,18.83L6.67,17.33C6.91,18.07 7.57,18.64 8.4,18.71C9.5,18.81 10.47,18 10.57,16.89L11,12H8V10H11.17L11.44,6.93C11.63,4.73 13.57,3.1 15.77,3.3C17.08,3.41 18.18,4.14 18.83,5.17L17.33,6.67C17.09,5.93 16.43,5.36 15.6,5.29Z',
        },
      ],
    },
    database: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z',
        },
      ],
    },
    hamburger: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z',
        },
      ],
    },
    tsd: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: `M20.144,4.5355c-0.0003,0-0.0007,0-0.001,0H3.857c-0.7495,0-1.357,0.6075-1.357,1.357
        c0,0.0004,0,0.0007,0,0.001v12.213h1.357V5.8935h16.286v12.213h-2.036v-4.75v-1.357v-1.3571v-1.357H16.75v1.357v1.3571v1.357v4.75
        h-1.357v-8.821h-1.358v8.822h-1.356v-3.393h-0.001v-1.358v-1.357v-1.3571h-1.357v1.3571v1.357v1.358v0.999v2.393H9.965V7.9285H8.607
        v10.178H7.25v-4.75v-1.357v-1.3571v-1.357H5.893v1.357v1.3571v1.357v4.75c-0.0005,0.7495,0.6066,1.3574,1.356,1.358
        c0.0003,0,0.0007,0,0.001,0h12.893c0.7495,0,1.357-0.6075,1.357-1.357c0-0.0003,0-0.0007,0-0.001V5.8935
        C21.5005,5.144,20.8934,4.536,20.144,4.5355z`,
        },
      ],
    },
    equalizer: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z',
        },
      ],
    },
    arrowDown: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z',
        },
      ],
    },
    arrowUp: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z',
        },
      ],
    },
    info: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
        },
      ],
    },
    infoInverted: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15H11V11h2Zm0-8H11V7h2Z',
        },
      ],
    },
    logout: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z',
        },
      ],
    },
    mapMarker: {
      viewbox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: `M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z`,
        },
      ],
    },
    search: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
        },
      ],
    },

    mail: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z',
        },
      ],
    },
    chevronUp: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z',
        },
      ],
    },
    chevronDown: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z',
        },
      ],
    },
    arrowDropDown: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7 10l5 5 5-5z',
        },
      ],
    },
    arrowDropDownV2: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'm7.41,8l4.59,4.58l4.59,-4.58l1.41,1.41l-6,6l-6,-6l1.41,-1.41z',
        },
      ],
    },
    arrowDropUp: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7 14l5-5 5 5z',
        },
      ],
    },
    sort: {
      viewBox: '0 0 384.964 384.964',
      paths: [
        {
          d: `M333.285,86.501L249.096,3.492c-4.68-4.632-12.512-4.68-17.191,0l-84.2,83.009c-4.752,4.704-4.74,12.319,0,17.011
          c4.74,4.704,12.439,4.704,17.179,0l63.46-62.558v187.589c0,6.641,5.438,12.03,12.151,12.03c6.713,0,12.151-5.39,12.151-12.03
          V40.954l63.46,62.558c4.752,4.704,12.439,4.704,17.179,0C338.036,98.808,338.036,91.193,333.285,86.501z`,
        },
        {
          d: `M220.079,281.464l-63.46,62.558V156.433c0-6.641-5.438-12.03-12.151-12.03c-6.713,0-12.151,5.39-12.151,12.03v187.589
          l-63.46-62.558c-4.752-4.704-12.439-4.704-17.179,0c-4.752,4.704-4.752,12.319,0,17.011l84.2,82.997
          c4.68,4.632,12.512,4.68,17.191,0l84.2-83.009c4.752-4.704,4.74-12.319,0-17.011C232.519,276.772,224.819,276.76,220.079,281.464z`,
        },
      ],
    },
    map: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z',
        },
      ],
    },
    gear: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z',
        },
      ],
    },
    money: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z',
        },
      ],
    },
    user: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z',
        },
      ],
    },
    userManagement: {
      viewBox: '0 0 48 48',
      paths: [
        {
          d: 'M24.00125,34.16255h-3.04382c-.0318,.29816-.05072,.60309-.05072,.91754v2.02826h3.0069v-2.02826c0-.33148,.03619-.63135,.08765-.91754Z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M31.36746,13.59297c-1.93274,0-3.6507,.92017-4.75183,2.34119,.57587-1.05194,.9043-2.25781,.9043-3.53925,0-4.07764-3.31732-7.3949-7.39471-7.3949-4.07782,0-7.39514,3.31726-7.39514,7.3949s3.31732,7.39514,7.39514,7.39514c2.42871,0,4.58105-1.18231,5.92999-2.99603-.4469,.84027-.70233,1.79724-.70233,2.81354,0,3.31647,2.69812,6.01459,6.01459,6.01459s6.01459-2.69812,6.01459-6.01459-2.69818-6.01459-6.01459-6.01459Zm-11.24225,3.19019c-2.41962,0-4.38824-1.96863-4.38824-4.38824s1.96863-4.38806,4.38824-4.38806,4.38782,1.96844,4.38782,4.38806-1.9682,4.38824-4.38782,4.38824Zm11.24225,5.83209c-1.65869,0-3.00775-1.34924-3.00775-3.00769s1.34906-3.00769,3.00775-3.00769,3.00769,1.34924,3.00769,3.00769-1.34906,3.00769-3.00769,3.00769Z',
        },
        {
          d: 'M24.00125,34.16255h-3.04382c-.0318,.29816-.05072,.60309-.05072,.91754v2.02826h3.0069v-2.02826c0-.33148,.03619-.63135,.08765-.91754Z',
        },
        {
          d: 'M38.06955,35.08009v2.02826h3.0069v-2.02826c0-.31445-.01892-.61938-.05072-.91754h-3.04382c.05145,.28619,.08765,.58606,.08765,.91754Z',
        },
        {
          d: 'M31.77182,27.49366h-1.15729c-1.99585-2.75757-5.62543-4.33936-9.96161-4.33936h-2.03784c-6.99329,0-11.69153,4.008-11.69153,9.97351v1.03473h3.0069v-1.03473c0-5.13641,4.48639-6.96661,8.68463-6.96661h2.03784c2.48584,0,4.62915,.62073,6.15485,1.73822-3.38831,.86401-5.51166,3.08649-5.85034,6.26312h3.04382c.56671-3.15369,4.05371-3.66199,6.21008-3.66199h1.56049c2.15637,0,5.64337,.5083,6.21008,3.66199h3.04382c-.4411-4.13794-3.90021-6.66888-9.25391-6.66888Z',
        },
      ],
    },
    cloudOff: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z',
        },
      ],
    },
    schedule: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z',
        },
      ],
    },
    thumbUp: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z',
        },
      ],
    },
    thumbDown: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z',
        },
      ],
    },
    invertedThumbUp: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M1,21H5V9H1ZM23,10a2.006,2.006,0,0,0-2-2H14.69l.95-4.57.03-.32a1.505,1.505,0,0,0-.44-1.06L14.17,1,7.59,7.59A1.955,1.955,0,0,0,7,9V19a2.006,2.006,0,0,0,2,2h9a1.987,1.987,0,0,0,1.84-1.22l3.02-7.05A1.976,1.976,0,0,0,23,12Z',
        },
      ],
    },
    invertedThumbDown: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M15,3H6A1.987,1.987,0,0,0,4.16,4.22L1.14,11.27A1.976,1.976,0,0,0,1,12v2a2.006,2.006,0,0,0,2,2H9.31l-.95,4.57-.03.32a1.505,1.505,0,0,0,.44,1.06L9.83,23l6.59-6.59A1.987,1.987,0,0,0,17,15V5A2.006,2.006,0,0,0,15,3Zm4,0V15h4V3Z',
        },
      ],
    },
    error: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
        },
      ],
    },
    more: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
      ],
    },
    moreHorizontal: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
      ],
    },
    cloud: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z',
        },
      ],
    },
    device: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: `M11.2688,12.0018v-1.461v-0.001v-1.461v-1.462h-1.462v1.462v1.461v0.001v1.461h-0.001v1.462
          c0.0005,0.8071,0.655,1.461,1.462,1.461h8.931c2.4221-3.7216,1.3687-8.702-2.3528-11.1242
          c-3.7216-2.4221-8.702-1.3687-11.1241,2.3528c-1.9238,2.9557-1.6967,6.8202,0.56,9.5303l-4.783,4.784l1.033,1.034l4.784-4.784
          c3.1257,2.6025,7.7028,2.4604,10.661-0.331h-2.506c-3.2286,1.6644-7.1952,0.3962-8.8595-2.8324
          c-1.6644-3.2287-0.3962-7.1952,2.8324-8.8596c0.9661-0.498,2.0405-0.7488,3.1271-0.73c3.5154,0.1136,6.3416,2.9319,6.465,6.447
          c0.0222,1.0578-0.2128,2.1052-0.685,3.052h-2.237v-1.462h0.001v-1.461v-0.001v-1.461v-1.462h-1.462v1.462v1.461v0.001v1.461v1.462
          h-1.461v-1.462v-1.461v-0.001v-1.461h-1.462v1.461v0.001v1.461v1.462h-1.462v-1.462H11.2688z`,
          // eslint-disable-next-line max-len
          // d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
        },
      ],
    },
    label: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z',
        },
      ],
    },
    comment: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z',
        },
      ],
    },
    fingerprint: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z',
        },
      ],
    },
    chevronRight: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
        },
      ],
    },
    chevronLeft: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z',
        },
      ],
    },
    online: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z',
        },
      ],
    },
    offline: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z',
        },
      ],
    },
    remove: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M19 13H5v-2h14v2z',
          fill: this.color,
          stroke: this.color,
        },
      ],
    },
    check: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
          fill: this.color,
          stroke: this.color,
          strokeWidth: 0,
        },
      ],
    },
    checkCircle: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z',
          fill: this.color,
          stroke: this.color,
          strokeWidth: 0,
        },
      ],
    },
    checkCircleFilled: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z',
          fill: this.color,
          stroke: this.color,
          strokeWidth: 0,
        },
      ],
    },
    plus: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
          fill: this.color,
          stroke: this.color,
          strokeWidth: 0,
        },
      ],
    },
    cross: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
          fill: 'white',
          stroke: 'white',
          strokeWidth: 0,
        },
      ],
    },
    signal: {
      viewBox: '-100 -100 200 200',
      paths: [
        {
          d: 'M 90 0 A 90 90 0 0 0 0 -90',
          fill: 'green',
          stroke: 0,
        },
      ],
    },
    data: {
      viewBox: '-100 -100 200 200',
      circles: [
        {
          r: 60,
          fill: 'skyblue',
        },
      ],
    },
    stream: {
      viewBox: '-100 -100 200 200',
      circles: [
        {
          r: 50,
          fill: 'orange',
        },
      ],
      lines: [
        {
          stroke: 'darkred',
          strokeWidth: 40,
          x1: -90,
          x2: 90,
          y1: 0,
          y2: 0,
        },
      ],
    },
    function: {
      viewBox: '-70 -90 140 140',
      lines: [
        {
          stroke: 'navy',
          strokeWidth: 20,
          x1: -70,
          x2: 70,
          y1: -70,
          y2: -70,
        },
        {
          stroke: 'navy',
          strokeWidth: 20,
          x1: -70,
          x2: 30,
          y1: 0,
          y2: 0,
        },
        {
          stroke: 'navy',
          strokeWidth: 20,
          x1: -70,
          x2: -30,
          y1: -35,
          y2: -35,
        },
        {
          stroke: 'navy',
          strokeWidth: 20,
          x1: -70,
          x2: -30,
          y1: 35,
          y2: 35,
        },
      ],
    },
    calendar: {
      // eslint-disable-next-line max-len
      path: `M13.3,126.4V37.4c0-2.4,.9-4.5,2.6-6.3c1.7-1.8,3.8-2.6 6.2-2.6h8.8v-6.7c0-3.1,1.1-5.7,3.2-7.9c2.2-2.2,4.7-3.3,7.8-3.3h4.4c3,0 5.6,1.1,7.8,3.3c2.2,2.2,3.2,4.8,3.2,7.9v6.7h26.4v-6.7c0-3.1,1.1-5.7 3.2-7.9c2.2-2.2,4.7-3.3,7.8-3.3h4.4c3,0,5.6,1.1,7.8,3.3c2.2,2.2,3.2 4.8,3.2,7.9v6.7h8.8c2.4,0,4.4,.9,6.2,2.6c1.7,1.8,2.6,3.8,2.6,6.3v88.9c0 2.4-.9,4.5-2.6,6.3c-1.7,1.8-3.8,2.6-6.2,2.6H22.1c-2.4,0-4.4-.9-6.2-2.6C14.2,130.8 13.3,128.8,13.3,126.4z M22.1,126.4h96.8V55.2H22.1V126.4z M39.7,41.9c0,.6,.2,1.2 .6,1.6c.4,.4,.9,.6,1.6,.6h4.4c.6,0,1.2-.2,1.6-.6c.4-.4 .6-.9,.6-1.6v-20c0-.6-.2-1.2-.6-1.6c-.4-.4-.9-.6-1.6-.6h-4.4c-.6,0-1.2,.2-1.6 .6c-.4,.4-.6,1-.6,1.6V41.9z M92.5,41.9c0,.6,.2,1.2,.6,1.6c.4,.4,.9,.6 1.6,.6h4.4c.6,0,1.2-.2,1.6-.6c.4-.4 .6-.9,.6-1.6v-20c0-.6-.2-1.2-.6-1.6c-.4-.4-.9-.6-1.6-.6h-4.4c-.6 0-1.2,.2-1.6,.6c-.4,.4-.6,1-.6,1.6V41.9z`,
      viewBox: '0 0 141 146',
    },
    adler: {
      viewBox: '0 285 1000 430',
      // eslint-disable-next-line max-len
      path: 'M500,709.7c-13.6,0-18.1-30.8-19-69c-8.7,23.6-25,41.4-45.1,42.1c-2.2,0.1-3.6-0.8-4.2-2.2c-0.6-1.1-0.8-2.5,0.5-5.7c7.2-17.3,13.4-34.8,18.8-52.4c-13.7,18.8-32.7,29.9-51.5,24.9c-2.2-0.6-3.3-1.8-3.6-3.3c-0.3-1.2-0.2-2.6,1.8-5.4c22.6-30.1,42.9-63.7,57.7-101.3c-5.3,4.3-10,8-13.9,11c-4.9,3.7-13.3,7-23.8,6c-4.1,4.8-7.6,8.7-9.5,10.7c-8,8.4,6.5,8.9,8,17c0.2,1-0.1,1.6-0.5,1.9c0.7,4.2-1.2,11.7-7.2,14.5c2.3-4,1.4-9-0.5-11.2c-3.7-4.2-12.5-7.4-22.7-5.3c-5.2,1.1-12.5,4.5-15.7,11c-2,4.1-1.5,9.4,1.5,13.6c-8.5-2.4-10.9-10.6-9.7-15.1c-2.1-8.6,7.1-15.6,14.4-17.5c-11.7-1-24.2,3.1-25.8,19.6c-6.7-7.1-4.8-14.5-0.7-20c1.4-8.2,14.9-10.9,21.3-9c-2.9-2.1-5.8-4-11.8-5.3c-3.2-0.3-7.9,0.1-12.1,6.4c-0.8-8.9,4.7-13.8,9.2-14.6c0.7-0.8,1.4-1.2,2.3-1.5c13.6-4.1,25.4,19.8,35.8,7.8c1.9-2.2,4.1-5.5,6.5-9.5c-5.1-4.4-8.4-11.9-0.7-23.6l18.3-27.8c-1.3,0.9-2.6,1.7-3.9,2.5c-13.8,8.5-29,14.6-42.6,14.6c-8.3,0-4.9-6.5-1-9.9c27.8-25.2,33.7-32.5,51.2-49.1c-18.5,12.3-38.7,31.6-56.3,46.3c-4,3.3-8.3,6.2-12.8,8.8c-14,8.2-29.3,13.9-42.9,13.7c-9.8-0.2-3.1-8.1,0.7-11.5c33.9-31.4,52.4-47.3,71.3-64.6c-21.3,12.2-52.2,42.7-74.8,60.9c-6.2,4.9-12.4,9.7-19.4,13.5c-14.2,7.8-29.7,13-43.3,12.3c-9.3-0.5-3.5-7.2,0.1-10.6c34.3-31.8,63.3-58.4,104.2-92.6c-16.5,9.5-77.7,61.7-110.9,91.5c-8.7,7.8-17.7,14.4-28.3,19.5c-14.6,7-30.4,11.4-43.9,10c-8.2-0.9-4.2-6.3-0.4-9.7c35.3-32.7,105.6-93.1,166.7-144.4c-17,8.5-125.9,100.3-170.2,139.4c-9.9,8.7-18.5,14.9-30.9,20.2c-14.9,6.3-30.9,10-44.3,8c-5.6-0.8-6.6-3.4-0.8-9c35.1-32.5,166.2-141,242.8-204.7C313.1,358.5,156.7,486.5,98,536.7c-12.6,10.7-22.8,17.1-38.7,22.8c-15.2,5.5-31.4,8.3-44.7,5.5c-5.5-1.2-6.6-3.9-0.3-9C48.9,521.6,323.9,282.8,370,290.4c21.1,2.2,16.3,25.8,10.8,41.6c-28.2,80.6,61.2,92.7,78,43.1c2.6-8.2,4-15.5,4.8-19.7c5-25.9,14.6-37.5,34.1-38.3c12.8-0.5,27.2,1.4,41.9,7c24,1,28.5,12.7,28,24.4c-6.8-3.1-23.8-2.9-31.2,6.8c0.8,4.2,2.2,11.5,4.8,19.7c16.8,49.6,106.2,37.6,78-43.1c-5.5-15.8-10.3-39.4,10.8-41.6c46.1-7.6,321.1,231.1,355.7,265.5c6.3,5.1,5.2,7.9-0.3,9c-13.3,2.8-29.5,0-44.7-5.5c-16-5.7-26.2-12.1-38.7-22.8c-58.7-50.2-215.1-178.2-230.3-184.8c76.6,63.8,207.8,172.2,242.8,204.7c5.8,5.6,4.8,8.2-0.8,9c-13.5,2-29.4-1.7-44.3-8c-12.4-5.3-21-11.5-30.9-20.2C794.1,498.4,685.2,406.5,668.3,398c61.2,51.3,131.4,111.7,166.7,144.4c3.7,3.4,7.8,8.8-0.4,9.7c-13.6,1.4-29.3-3-43.9-10c-10.6-5.1-19.6-11.7-28.3-19.5c-33.2-29.9-94.4-82-110.9-91.5c40.9,34.2,69.9,60.8,104.2,92.6c3.6,3.4,9.5,10.1,0.1,10.6c-13.6,0.7-29.1-4.5-43.3-12.3c-7-3.8-13.2-8.6-19.4-13.5c-22.6-18.2-53.5-48.7-74.8-60.9c18.9,17.3,37.4,33.2,71.3,64.6c3.7,3.4,10.5,11.3,0.7,11.5c-13.6,0.3-29-5.5-42.9-13.7c-4.5-2.7-8.8-5.5-12.8-8.8c-17.6-14.7-37.8-34.1-56.3-46.3c17.5,16.6,23.4,23.9,51.2,49.1c3.9,3.5,7.2,10-1,9.9c-13.6,0-28.8-6.1-42.6-14.6c-1.3-0.8-2.6-1.7-3.9-2.5l18.3,27.8c7.7,11.7,4.4,19.2-0.7,23.6c2.4,4,4.6,7.4,6.4,9.5c10.4,12,22.2-11.9,35.8-7.8c0.9,0.3,1.7,0.6,2.3,1.5c4.6,0.8,10.1,5.7,9.2,14.6c-4.2-6.3-8.9-6.7-12.1-6.4c-6,1.2-8.9,3.2-11.8,5.3c6.3-1.9,19.9,0.7,21.3,9c4.1,5.5,6,12.9-0.7,20c-1.6-16.4-14.1-20.6-25.8-19.6c7.3,1.9,16.5,8.9,14.4,17.5c1.1,4.6-1.2,12.8-9.7,15.1c2.9-4.2,3.4-9.5,1.5-13.6c-3.1-6.5-10.5-9.9-15.7-11c-10.2-2.1-19,1.1-22.7,5.3c-1.9,2.2-2.8,7.2-0.5,11.2c-6-2.7-7.9-10.3-7.2-14.5c-0.4-0.4-0.7-0.9-0.5-1.9c1.5-8.2,16-8.6,8-17c-1.9-2-5.3-5.9-9.5-10.7c-10.5,1-18.8-2.3-23.8-6c-3.9-3-8.7-6.7-13.9-11c14.8,37.7,35.1,71.2,57.7,101.3c2,2.7,2.1,4.1,1.8,5.4c-0.3,1.5-1.4,2.7-3.6,3.3c-18.8,5-37.7-6.2-51.5-24.9c5.3,17.5,11.5,35,18.8,52.4c1.3,3.2,1.1,4.6,0.5,5.7c-0.7,1.3-2,2.2-4.2,2.2c-20.1-0.6-36.4-18.4-45.1-42.1C518.1,679,513.6,709.7,500,709.7L500,709.7z M503.1,324c10.9,0.1,24.2,2.6,30.5,5.6c-2,3.3-5.8,4.5-9.8,3.9C516.4,332.5,510.3,328.5,503.1,324L503.1,324z',
    },
    location: {
      viewBox: '-2 -2 28 28',
      // eslint-disable-next-line max-len
      path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
    },
    expandTriangle: {
      viewBox: '-100 -100 200 200',
      // eslint-disable-next-line max-len
      polygon: '60,0 -30,60, -30,-60',
    },
    /* eslint-disable-next-line , , , , , , , , ,  */
    trash: {
      viewBox: '0 0 24 24',
      // eslint-disable-next-line max-len
      paths: [
        {
          d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
        },
      ],
    },
    eagle: {
      viewBox: '0 0 700 550',
      paths: [
        // eslint-disable-next-line max-len
        'm682.06116,178.51215c-29.97071,1.00982 -74.98535,-1.30762 -119.98694,-58.47876c0,0 97.09778,37.54449 113.9281,-23.30347c0,0 -67.32117,12.94635 -108.74951,-20.71423c0,0 99.68701,-3.88392 100.98169,-63.4372c0,0 -49.19629,33.66058 -137.23157,20.71417c0,0 22.00879,-19.41955 12.94641,-34.9552c0,0 -9.0625,27.18738 -45.31238,24.59809c-36.24981,-2.58924 -58.25866,10.35711 -56.96405,28.48205c1.29468,18.12494 23.30353,24.59809 23.30353,24.59809s-20.71423,22.00885 -7.76788,51.78552c7.76788,19.41955 18.12494,22.00885 14.24102,41.4284c0,0 -9.06243,6.47321 -22.00885,-7.76782c-12.94635,-14.24103 -22.00878,-11.65173 -29.77661,-5.17853c-7.76782,6.47315 -16.83032,-3.88397 -18.12494,-14.24102c-1.29461,-10.35712 -3.88391,-27.18738 -3.88391,-27.18738s16.83026,-7.76782 25.89276,2.58923c0,0 6.47315,-9.06244 -18.12493,-12.94635c-6.47321,-5.17853 -12.94635,-12.94635 -14.24103,-23.30346c-1.29462,-10.35712 0,-33.66059 -11.65174,-53.08014c-1.29461,-2.5893 0,-3.88392 0,-3.88392s15.50983,-5.16558 24.57227,-18.09899c-0.66028,0.50482 -13.29596,10.2276 -27.16156,6.44726c-18.12488,-2.58929 -37.54443,-18.12494 -53.08014,-5.17859c0,0 -14.24097,-7.76782 -32.36591,-3.88391s-11.65173,20.71423 -11.65173,20.71423s5.17853,-10.35711 18.12494,-7.76782c1.29462,1.29462 5.17853,3.88391 10.35706,15.53565c0,0 20.71423,1.29461 23.30352,29.77667c0,0 -12.94641,-7.76782 -22.00885,-14.24103l-40.13379,0c0,0 -9.06243,-1.29462 -12.94635,-9.06244c0,0 0,11.65174 9.06244,12.94635c9.0625,1.29462 44.0177,1.29462 44.0177,1.29462s18.12494,11.65173 19.41956,14.24103s0,5.17852 0,5.17852s-15.53564,-7.76782 -33.66058,-3.88391c0,0 29.77667,7.76783 31.07129,18.12494c1.29467,10.35712 0,16.83033 0,20.71424c-5.17853,5.17852 -7.76783,7.76782 -14.24103,7.76782c-6.47315,0 -15.53565,3.88391 -16.83026,10.35705c0,0 14.24102,-11.65173 28.48199,-2.58923c0,0 0,41.42841 -27.18738,40.13373c-9.06244,-1.29462 -12.94635,-10.35712 -25.8927,-9.06244c-12.94641,1.29462 -27.18744,14.24103 -34.95526,20.71417c-5.17853,-1.29461 -11.65173,-2.58923 -10.35705,-20.71417c1.29461,-18.12494 10.35705,-27.18738 9.06243,-46.60693c-1.29461,-19.41962 -14.24102,-28.48206 -14.24102,-28.48206s19.41955,-10.35712 18.12494,-24.59808c-1.29462,-14.24103 -16.83026,-24.59815 -40.13373,-23.30347c-23.30353,1.29462 -54.37482,-6.47321 -66.02655,-24.59814c0,0 -3.88391,18.12493 11.65173,27.18737l0,2.5893c0,0 -97.09772,2.58929 -137.23144,-19.41956c0,0 -1.29468,49.19623 110.04406,60.84796c0,0 -41.42828,33.66059 -104.86554,22.00885c0,0 2.5893,49.19617 112.63337,29.77662c0,0 -46.60688,51.78552 -108.74946,56.96405c0,0 20.71418,49.19622 120.40119,-1.29462c0,0 -31.07129,54.37475 -91.91919,89.32995c0,0 37.54449,41.42841 117.79901,-36.23687c-0.42718,1.1781 -28.77978,76.57776 -68.60284,102.26343c0,0 44.0177,42.72302 107.45489,-69.91047c0,0 7.76782,66.02655 -41.4284,117.81202c0,0 37.54449,28.48205 88.03534,-67.32111c0,0 3.88391,40.13373 -12.94636,72.49969c0,0 47.90162,11.65174 59.55335,-69.91046c0,0 16.83026,68.61579 -40.13379,103.57105l25.89276,2.58923l-1.1781,2.73169l10.25354,11.82001l2.5763,-5.4892l24.59808,37.5445c0,0 -9.06244,-54.37482 -1.29462,-78.9729c2.5893,-1.29468 31.07129,-37.5445 31.07129,-37.5445l17.90161,10.01703l18.34827,-10.01703c0,0 33.66058,23.30347 54.37475,71.20508c2.5893,5.17853 -3.88391,45.31232 -3.88391,45.31232s15.53565,-36.24988 19.41956,-42.72309l0.91925,1.29468l12.84277,-7.78082l-0.81561,-1.28168l27.18738,-2.58923c0,0 -66.02655,-32.36597 -66.02655,-99.68714c0,0 33.66058,78.9729 77.67828,66.02655c0,-1.29467 -38.83911,-45.31231 -33.66064,-75.08899c0,0 49.19629,85.44605 108.74963,67.32117c0,0 -63.43725,-34.95526 -72.49975,-120.40131c0,0 67.32116,111.33881 126.87451,69.9104c0,0 -51.77259,-14.24096 -89.30408,-99.64825c1.55359,1.78662 62.23328,71.12738 119.00305,40.315c0.89331,-0.479 1.77368,-0.98394 2.66699,-1.51471c0,0 -0.71203,-0.34954 -2.03259,-1.0227c-11.48352,-5.92945 -68.75818,-37.4798 -98.94922,-90.89655c0,0 82.24842,57.68909 114.7826,15.85932c3.28845,-4.22052 6.07189,-9.45081 8.208,-15.85932c-1.79944,0.0777 -3.66382,0.1554 -5.59289,0.2201zm-351.72705,-162.04975c16.83032,0 19.41955,6.47315 19.41955,6.47315l-10.35705,0c0,0 2.58923,3.88397 -3.88391,2.58929c-6.47321,-1.29462 -5.17859,-9.06244 -5.17859,-9.06244zm29.77667,318.48078c0,0 -79.69788,-34.70923 -78.9729,-155.35645c0,0 126.87451,0 141.11548,0c0,27.18738 -1.29462,120.40125 -62.14258,155.35645z',
      ],
    },
    debug: {
      viewBox: '0 0 100 125',
      paths: [
        // eslint-disable-next-line max-len
        'M20.796,34l-6.036-5.987c-1.122-1.124-2.938-1.092-4.062,0.028c-1.123,1.12-1.126,2.956-0.007,4.079l6.879,6.468  C18.108,39.128,18.841,39,19.604,39h5.596c-3.985,5-6.601,11-7.569,17H7.872C6.285,56,5,57.413,5,59c0,1.586,1.285,3,2.872,3h9.335  c0.05,5,1.315,10,3.522,14h-2.083c-0.763,0-1.495,0.436-2.034,0.977l-6.878,6.965c-1.12,1.123-1.118,2.975,0.005,4.095  c0.562,0.559,1.294,0.855,2.028,0.855c0.736,0,1.473-0.278,2.033-0.841L19.839,82h4.638C30.127,89,39,93.544,48,94.055V34H20.796z',
        // eslint-disable-next-line max-len
        'M92.128,56h-9.961c-1.24-6-4.434-12-8.176-17h6.405c0.763,0,1.495,0.137,2.034-0.404l6.879-6.679  c1.119-1.124,1.116-2.832-0.007-3.952c-1.125-1.121-2.941-1.131-4.062-0.007L79.204,34H52v60.033C61,93.447,69.713,88,75.363,82  h4.798l6.038,6.059c0.561,0.563,1.297,0.847,2.033,0.847c0.734,0,1.467-0.279,2.028-0.837c1.123-1.12,1.125-2.938,0.005-4.061  l-6.878-7.031C82.849,76.436,82.116,76,81.354,76h-2.2c2.234-4,3.517-9,3.567-14h9.407C93.715,62,95,60.586,95,59  C95,57.413,93.715,56,92.128,56z',
        // eslint-disable-next-line max-len
        'M31.421,30h37.158c0-7-3.473-12.264-8.687-15.555l3.75-3.673c1.122-1.121,1.122-2.902,0-4.024  c-1.122-1.121-2.939-1.102-4.062,0.02l-5.424,5.434c-1.338-0.306-2.726-0.478-4.157-0.478s-2.819,0.179-4.157,0.485l-5.425-5.423  c-1.122-1.121-2.939-1.121-4.062,0s-1.122,2.941,0,4.063l3.75,3.597C34.894,17.737,31.421,23,31.421,30z',
      ],
    },
    play: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M8 5v14l11-7z',
        },
      ],
    },
    pause: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M6,19h4V5H6ZM14,5V19h4V5Z',
        },
      ],
    },
    face_agent: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M18.72,14.76C19.07,13.91 19.26,13 19.26,12C19.26,11.28 19.15,10.59 18.96,9.95C18.31,10.1 17.63,10.18 16.92,10.18C13.86,10.18 11.15,8.67 9.5,6.34C8.61,8.5 6.91,10.26 4.77,11.22C4.73,11.47 4.73,11.74 4.73,12A7.27,7.27 0 0,0 12,19.27C13.05,19.27 14.06,19.04 14.97,18.63C15.54,19.72 15.8,20.26 15.78,20.26C14.14,20.81 12.87,21.08 12,21.08C9.58,21.08 7.27,20.13 5.57,18.42C4.53,17.38 3.76,16.11 3.33,14.73H2V10.18H3.09C3.93,6.04 7.6,2.92 12,2.92C14.4,2.92 16.71,3.87 18.42,5.58C19.69,6.84 20.54,8.45 20.89,10.18H22V14.67H22V14.69L22,14.73H21.94L18.38,18L13.08,17.4V15.73H17.91L18.72,14.76M9.27,11.77C9.57,11.77 9.86,11.89 10.07,12.11C10.28,12.32 10.4,12.61 10.4,12.91C10.4,13.21 10.28,13.5 10.07,13.71C9.86,13.92 9.57,14.04 9.27,14.04C8.64,14.04 8.13,13.54 8.13,12.91C8.13,12.28 8.64,11.77 9.27,11.77M14.72,11.77C15.35,11.77 15.85,12.28 15.85,12.91C15.85,13.54 15.35,14.04 14.72,14.04C14.09,14.04 13.58,13.54 13.58,12.91A1.14,1.14 0 0,1 14.72,11.77Z',
        },
      ],
    },
    help_circle: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z',
        },
      ],
    },
    circle: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z',
        },
      ],
    },
    organisation_active: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M18,15H16v2h2m0-6H16v2h2m2,6H12V17h2V15H12V13h2V11H12V9h8M10,7H8V5h2m0,6H8V9h2m0,6H8V13h2m0,6H8V17h2M6,7H4V5H6m0,6H4V9H6m0,6H4V13H6m0,6H4V17H6M12,7V3H2V21H22V7Z',
        },
      ],
    },
    notification_bell: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M10,21H14C14,22.1,13.1,23,12,23S10,22.1,10,21M21,19V20H3V19L5,17V11C5,7.9,7,5.2,10,4.3V4C10,2.9,10.9,2,12,2S14,2.9,14,4V4.3C17,5.2,19,7.9,19,11V17L21,19M17,11C17,8.2,14.8,6,12,6S7,8.2,7,11V18H17V11Z',
        },
      ],
    },
    notification_bell_closed: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M21,19V20H3V19L5,17V11C5,7.9,7.03,5.17,10,4.29C10,4.19,10,4.1,10,4A2,2,0,0,1,12,2A2,2,0,0,1,14,4C14,4.1,14,4.19,14,4.29C16.97,5.17,19,7.9,19,11V17L21,19M14,21A2,2,0,0,1,12,23A2,2,0,0,1,10,21',
        },
      ],
    },
    // TODO: This one is weird
    csv: {
      viewBox: '0 0 30 30',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M26,13h-9c-1.1,0-2,0.9-2,2v7h-3H8v9h4h3v2c0,1.1,0.9,2,2,2h13c1.1,0,2-0.9,2-2V19L26,13z M12.7,30.1 c-0.2,0-0.4,0-0.7-0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.2-0.7-0.4-1-0.7s-0.5-0.7-0.7-1.1s-0.3-0.9-0.3-1.5c0-0.6,0.1-1.1,0.3-1.5 c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.5,1-0.7c0.2-0.1,0.3-0.1,0.5-0.2c0.2-0.1,0.5-0.1,0.7-0.1c0.4,0,0.8,0.1,1.2,0.3 s0.6,0.4,0.9,0.6l-0.8,1c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.1-0.7,0.2c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.7,0.2,1.3,0.5,1.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.2,0.7,0.2c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.6-0.5l0.8,1C14.3,29.8,13.6,30.1,12.7,30.1z M17.1,25.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2s0.3,0.1,0.4,0.2l0.9,0.4c0.4,0.2,0.8,0.4,1,0.7c0.2,0.3,0.4,0.7,0.4,1.2c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.5c-0.3,0.1-0.7,0.2-1.1,0.2c-0.2,0-0.5,0-0.7-0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.2-0.8-0.4-1.2-0.7l0.9-1.1c0.2,0.2,0.5,0.4,0.8,0.5c0,0,0.1,0,0.1,0c0.2,0.1,0.5,0.2,0.7,0.2c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.2-0.3,0.2-0.5c0-0.1,0-0.2-0.1-0.3s-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.2L17,27l-0.2-0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.2-0.3-0.3-0.5s-0.1-0.4-0.1-0.7c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.3,0.8-0.4c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.1,0.9-0.1c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7l-0.8,1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.3,0-0.5,0.1-0.6,0.2C17.1,24.6,17,24.8,17,25C17,25.1,17,25.2,17.1,25.2z M30,33H17v-2h11v-9H17v-7h8v5h5V33z M20.5,23.2h1.6l0.8,3.2c0.1,0.4,0.2,0.7,0.3,1.1s0.2,0.7,0.3,1.1h0c0.1-0.4,0.2-0.7,0.3-1.1s0.2-0.7,0.3-1.1l0.8-3.2h1.6L24.5,30h-1.9L20.5,23.2z',
          transform: 'translate(-8 -8)',
        },
      ],
    },
    device_database: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M8,0C3.58,0,0,1.79,0,4V14c0,2.21,3.59,4,8,4s8-1.79,8-4V4c0-2.21-3.58-4-8-4m6,14c0,.5-2.13,2-6,2s-6-1.5-6-2V11.77A14.032,14.032,0,0,0,8,13a14.032,14.032,0,0,0,6-1.23V14m0-4.55A10.786,10.786,0,0,1,8,11,10.786,10.786,0,0,1,2,9.45V6.64A12.555,12.555,0,0,0,8,8a12.555,12.555,0,0,0,6-1.36V9.45M8,6C4.13,6,2,4.5,2,4S4.13,2,8,2s6,1.5,6,2S11.87,6,8,6',
          transform: 'translate(4 3)',
        },
      ],
    },
    simulated: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M20,18a2,2,0,0,0,1.99-2L22,6a2,2,0,0,0-2-2H4A1.993,1.993,0,0,0,2,6V16a2,2,0,0,0,2,2H0v2H24V18ZM4,16V6H20V16.01L4,16Z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M13,9.13c-3.89.54-5.44,3.2-6,5.87,1.39-1.87,3.22-2.72,6-2.72v2.19l4-3.74L13,7Z',
        },
      ],
    },
    calculated: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M16,0H2A2.006,2.006,0,0,0,0,2V16a2.006,2.006,0,0,0,2,2H16a2.006,2.006,0,0,0,2-2V2a2.006,2.006,0,0,0-2-2M10,4.1,11.1,3l1.4,1.4L13.9,3,15,4.1,13.6,5.5,15,6.9,13.9,8,12.5,6.6,11.1,8,10,6.9l1.4-1.4L10,4.1m-6.8.6h5V6.2h-5ZM8.5,13h-2v2H5V13H3V11.5H5v-2H6.5v2h2V13M15,14.2H10V12.7h5Zm0-2.4H10V10.3h5Z',
          transform: 'translate(3 3)',
        },
      ],
    },
    physical: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M19,7H5A2.006,2.006,0,0,0,3,9v6a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V9A2.006,2.006,0,0,0,19,7Zm0,8H5V9H19Z',
        },
        {
          // eslint-disable-next-line max-len
          d: 'M10,4a2,2,0,1,0,2,2A2.006,2.006,0,0,0,10,4Z',
          transform: 'translate(6 6)',
        },
      ],
    },
    delete: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M6,19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V7H6ZM19,4H15.5l-1-1h-5l-1,1H5V6H19Z',
        },
      ],
    },
    colourPalette: {
      viewBox: '0 0 24 24',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M12,3a9,9,0,0,0,0,18,1.5,1.5,0,0,0,1.11-2.51A1.494,1.494,0,0,1,14.23,16H16a5,5,0,0,0,5-5C21,6.58,16.97,3,12,3ZM6.5,12A1.5,1.5,0,1,1,8,10.5,1.5,1.5,0,0,1,6.5,12Zm3-4A1.5,1.5,0,1,1,11,6.5,1.5,1.5,0,0,1,9.5,8Zm5,0A1.5,1.5,0,1,1,16,6.5,1.5,1.5,0,0,1,14.5,8Zm3,4A1.5,1.5,0,1,1,19,10.5,1.5,1.5,0,0,1,17.5,12Z',
        },
      ],
    },
    successCircle: {
      viewBox: '0 0 60 60',
      paths: [
        {
          // eslint-disable-next-line max-len
          d: 'M30.0001 0.666626C24.1985 0.666626 18.5272 2.387 13.7034 5.61018C8.87953 8.83337 5.1198 13.4146 2.89963 18.7746C0.679458 24.1345 0.0985599 30.0325 1.23039 35.7226C2.36223 41.4127 5.15596 46.6394 9.2583 50.7418C13.3606 54.8441 18.5873 57.6378 24.2774 58.7697C29.9676 59.9015 35.8655 59.3206 41.2255 57.1004C46.5854 54.8802 51.1667 51.1205 54.3899 46.2967C57.6131 41.4728 59.3334 35.8015 59.3334 30C59.3306 22.2211 56.2392 14.7617 50.7388 9.26128C45.2383 3.76083 37.7789 0.669453 30.0001 0.666626ZM24.1334 44.6666L9.46676 30L13.6001 25.8666L24.1334 36.368L46.4001 14.1013L50.5334 18.2666L24.1334 44.6666Z',
        },
      ],
    },
    uploadTray: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
        },
      ],
    },
    'emmaTreeNode-metric': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.2222 17H12.7778V11H11.2222V17ZM5 17H6.55556V11H5V17ZM17.4444 17H19V11H17.4444V17Z',
        },
        {
          d: 'M9.66667 17H8.11111V8H9.66667V17Z',
        },
        {
          d: 'M14.3333 17H15.8889V8H14.3333V17Z',
        },
      ],
    },
    'emmaTreeNode-default': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12.7074 12.7074C12.512 12.9025 12.2762 13 12 13C11.7238 13 11.488 12.9025 11.2926 12.7074C11.0975 12.512 11 12.2762 11 12C11 11.7238 11.0975 11.488 11.2926 11.2926C11.488 11.0975 11.7238 11 12 11C12.2762 11 12.512 11.0975 12.7074 11.2926C12.9025 11.488 13 11.7238 13 12C13 12.2762 12.9025 12.512 12.7074 12.7074Z',
        },
      ],
      circles: [
        {
          r: 8,
          cx: 12,
          cy: 12,
          fill: 'none',
        },
      ],
    },
    'emmaTreeNode-site': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.75 16.55C13.4833 15.1667 14.7917 13.8373 15.675 12.562C16.5583 11.2873 17 10.0667 17 8.9C17 7.91667 16.8207 7.079 16.462 6.387C16.104 5.69567 15.6627 5.13733 15.138 4.712C14.6127 4.28733 14.0417 3.979 13.425 3.787C12.8083 3.59567 12.25 3.5 11.75 3.5C11.25 3.5 10.6917 3.59567 10.075 3.787C9.45833 3.979 8.88767 4.28733 8.363 4.712C7.83767 5.13733 7.39567 5.69567 7.037 6.387C6.679 7.079 6.5 7.91667 6.5 8.9C6.5 10.0667 6.94167 11.2873 7.825 12.562C8.70833 13.8373 10.0167 15.1667 11.75 16.55ZM11.75 18.45C9.48333 16.75 7.79167 15.1123 6.675 13.537C5.55833 11.9623 5 10.4167 5 8.9C5 7.76667 5.20433 6.77067 5.613 5.912C6.021 5.054 6.546 4.33333 7.188 3.75C7.82933 3.16667 8.55433 2.72933 9.363 2.438C10.171 2.146 10.9667 2 11.75 2C12.5333 2 13.3293 2.146 14.138 2.438C14.946 2.72933 15.6707 3.16667 16.312 3.75C16.954 4.33333 17.4793 5.054 17.888 5.912C18.296 6.77067 18.5 7.76667 18.5 8.9C18.5 10.4167 17.9417 11.9623 16.825 13.537C15.7083 15.1123 14.0167 16.75 11.75 18.45ZM11.75 10.5C12.2333 10.5 12.646 10.3293 12.988 9.988C13.3293 9.646 13.5 9.23333 13.5 8.75C13.5 8.26667 13.3293 7.854 12.988 7.512C12.646 7.17067 12.2333 7 11.75 7C11.2667 7 10.854 7.17067 10.512 7.512C10.1707 7.854 10 8.26667 10 8.75C10 9.23333 10.1707 9.646 10.512 9.988C10.854 10.3293 11.2667 10.5 11.75 10.5ZM5 20.5V19H18.5V20.5H5Z',
        },
      ],
    },
    'emmaTreeNode-building': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M0.5 19.3125V8.1125L6.5 5.5625V7.5625L11.5 5.5625V8.3125H19.5V19.3125H0.5ZM2 17.8125H18V9.8125H10V7.7625L5 9.7625V7.8125L2 9.1375V17.8125ZM9.125 15.5875H10.875V12.0375H9.125V15.5875ZM5.125 15.5875H6.875V12.0375H5.125V15.5875ZM13.125 15.5875H14.875V12.0375H13.125V15.5875ZM19.5 8.3125H15.45L16.45 0.6875H18.55L19.5 8.3125ZM2 17.8125H18H2Z',
        },
      ],
    },
    'emmaTreeNode-machine': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M4.10835 20.5004V19.0004H7.15835L4.85 9.52542C4.41667 9.29208 4.06267 8.95442 3.788 8.51242C3.51267 8.07109 3.375 7.58375 3.375 7.05042C3.375 6.30042 3.64167 5.65442 4.175 5.11242C4.70833 4.57109 5.35833 4.30042 6.125 4.30042C6.75833 4.30042 7.30833 4.48775 7.775 4.86242C8.24167 5.23775 8.56667 5.71709 8.75 6.30042H12.175V5.05042C12.175 4.85042 12.246 4.67542 12.388 4.52542C12.5293 4.37542 12.7083 4.30042 12.925 4.30042C13.0583 4.30042 13.1793 4.33375 13.288 4.40042C13.396 4.46709 13.4833 4.56709 13.55 4.70042V4.82542L15.3 3.17542C15.45 3.04209 15.6207 2.95875 15.812 2.92542C16.004 2.89209 16.1917 2.91709 16.375 3.00042L20.2 4.77542C20.3667 4.85875 20.4833 4.97942 20.55 5.13742C20.6167 5.29609 20.6167 5.45042 20.55 5.60042C20.4667 5.75042 20.35 5.85042 20.2 5.90042C20.05 5.95042 19.9 5.94209 19.75 5.87542L16.05 4.15042L13.675 6.35042V7.75042L16.05 9.90042L19.75 8.20042C19.9 8.13375 20.0543 8.12542 20.213 8.17542C20.371 8.22542 20.4833 8.32542 20.55 8.47542C20.6333 8.64209 20.6373 8.79642 20.562 8.93842C20.4873 9.07975 20.3667 9.19208 20.2 9.27542L16.375 11.1004C16.1917 11.1838 16.004 11.2088 15.812 11.1754C15.6207 11.1421 15.45 11.0504 15.3 10.9004L13.55 9.30042V9.42542C13.4833 9.52542 13.396 9.61309 13.288 9.68842C13.1793 9.76309 13.0583 9.80042 12.925 9.80042C12.7083 9.80042 12.5293 9.72942 12.388 9.58742C12.246 9.44609 12.175 9.26709 12.175 9.05042V7.80042H8.75C8.7 7.98375 8.62933 8.15875 8.538 8.32542C8.446 8.49209 8.34167 8.65042 8.225 8.80042L12.8833 19.0004H16.375V20.5004H4.10835ZM6.125 8.30042C6.475 8.30042 6.771 8.17942 7.013 7.93742C7.25433 7.69609 7.375 7.40042 7.375 7.05042C7.375 6.70042 7.25433 6.40442 7.013 6.16242C6.771 5.92109 6.475 5.80042 6.125 5.80042C5.775 5.80042 5.47933 5.92109 5.238 6.16242C4.996 6.40442 4.875 6.70042 4.875 7.05042C4.875 7.40042 4.996 7.69609 5.238 7.93742C5.47933 8.17942 5.775 8.30042 6.125 8.30042ZM8.70835 19.0004H11.1583L7.025 9.70042C6.975 9.73375 6.89167 9.76275 6.775 9.78742C6.65833 9.81275 6.56667 9.81709 6.5 9.80042L8.70835 19.0004Z',
        },
      ],
    },
    'emmaTreeNode-device': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M9.5001 14.4996V9.49961H14.5001V14.4996H9.5001ZM11.0001 12.9996H13.0001V10.9996H11.0001V12.9996ZM9.2501 20.2746V18.4996H7.3001C6.8001 18.4996 6.3751 18.3246 6.0251 17.9746C5.6751 17.6246 5.5001 17.1996 5.5001 16.6996V14.7496H3.7251V13.2496H5.5001V10.7496H3.7251V9.24961H5.5001V7.29961C5.5001 6.79961 5.6751 6.37461 6.0251 6.02461C6.3751 5.67461 6.8001 5.49961 7.3001 5.49961H9.2501V3.72461H10.7501V5.49961H13.2501V3.72461H14.7501V5.49961H16.7001C17.2001 5.49961 17.6251 5.67461 17.9751 6.02461C18.3251 6.37461 18.5001 6.79961 18.5001 7.29961V9.24961H20.2751V10.7496H18.5001V13.2496H20.2751V14.7496H18.5001V16.6996C18.5001 17.1996 18.3251 17.6246 17.9751 17.9746C17.6251 18.3246 17.2001 18.4996 16.7001 18.4996H14.7501V20.2746H13.2501V18.4996H10.7501V20.2746H9.2501ZM16.7001 16.9996C16.7668 16.9996 16.8334 16.9663 16.9001 16.8996C16.9668 16.8329 17.0001 16.7663 17.0001 16.6996V7.29961C17.0001 7.23294 16.9668 7.16628 16.9001 7.09961C16.8334 7.03294 16.7668 6.99961 16.7001 6.99961H7.3001C7.23343 6.99961 7.16676 7.03294 7.1001 7.09961C7.03343 7.16628 7.0001 7.23294 7.0001 7.29961V16.6996C7.0001 16.7663 7.03343 16.8329 7.1001 16.8996C7.16676 16.9663 7.23343 16.9996 7.3001 16.9996H16.7001Z',
        },
      ],
    },
    'emmaTreeNode-steam': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 21.5C10.6833 21.5 9.446 21.25 8.288 20.75C7.12933 20.25 6.125 19.575 5.275 18.725C4.425 17.875 3.75 16.8707 3.25 15.712C2.75 14.554 2.5 13.3167 2.5 12C2.5 10.6833 2.75 9.44567 3.25 8.287C3.75 7.129 4.425 6.125 5.275 5.275C6.125 4.425 7.12933 3.75 8.288 3.25C9.446 2.75 10.6833 2.5 12 2.5C13.3167 2.5 14.5543 2.75 15.713 3.25C16.871 3.75 17.875 4.425 18.725 5.275C19.575 6.125 20.25 7.129 20.75 8.287C21.25 9.44567 21.5 10.6833 21.5 12C21.5 13.3167 21.25 14.554 20.75 15.712C20.25 16.8707 19.575 17.875 18.725 18.725C17.875 19.575 16.871 20.25 15.713 20.75C14.5543 21.25 13.3167 21.5 12 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z',
        },
        {
          d: 'M8 8L16 8L16 9.5L8 9.5L8 8Z',
        },
        {
          d: 'M14.4651 17.366L14.3856 18H15.9227L15.9757 17.4717C16.0464 16.8201 15.9627 16.1904 15.7245 15.5825C15.4856 14.9753 15.11 14.4164 14.5976 13.9057C14.2442 13.5711 14.0057 13.2143 13.882 12.8353C13.7584 12.4571 13.723 12.0566 13.776 11.634L13.8555 11H12.3184L12.2654 11.5283C12.1947 12.1623 12.2742 12.774 12.5039 13.3636C12.7336 13.9539 13.0958 14.5044 13.5905 15.0151C13.9439 15.3673 14.1955 15.7417 14.3453 16.1383C14.4958 16.5341 14.5358 16.9434 14.4651 17.366Z',
        },
        {
          d: 'M10.2247 17.366L10.1452 18H11.6823L11.7353 17.4717C11.7883 16.8377 11.7 16.2126 11.4703 15.5962C11.2406 14.9799 10.8696 14.4164 10.3572 13.9057C10.0038 13.5535 9.76104 13.1925 9.62888 12.8226C9.49602 12.4528 9.46492 12.0566 9.53559 11.634L9.6151 11H8.07795L8.02494 11.5283C7.95427 12.1623 8.03378 12.774 8.26347 13.3636C8.49316 13.9539 8.85536 14.5044 9.35008 15.0151C9.70345 15.3673 9.9554 15.7417 10.1059 16.1383C10.2558 16.5341 10.2953 16.9434 10.2247 17.366Z',
        },
        {
          d: 'M1 14L3 14L3 10L1 10L1 14Z',
        },
        {
          d: 'M21 14L23 14L23 10L21 10L21 14Z',
        },
      ],
    },
    'emmaTreeNode-water': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 21.5C10.6833 21.5 9.446 21.25 8.288 20.75C7.12933 20.25 6.125 19.575 5.275 18.725C4.425 17.875 3.75 16.8707 3.25 15.712C2.75 14.554 2.5 13.3167 2.5 12C2.5 10.6833 2.75 9.44567 3.25 8.287C3.75 7.129 4.425 6.125 5.275 5.275C6.125 4.425 7.12933 3.75 8.288 3.25C9.446 2.75 10.6833 2.5 12 2.5C13.3167 2.5 14.5543 2.75 15.713 3.25C16.871 3.75 17.875 4.425 18.725 5.275C19.575 6.125 20.25 7.129 20.75 8.287C21.25 9.44567 21.5 10.6833 21.5 12C21.5 13.3167 21.25 14.554 20.75 15.712C20.25 16.8707 19.575 17.875 18.725 18.725C17.875 19.575 16.871 20.25 15.713 20.75C14.5543 21.25 13.3167 21.5 12 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z',
        },
        {
          d: 'M8 8L15.5 8L15.5 9.5L8 9.5L8 8Z',
        },
        {
          d: 'M13.5749 17.0252C13.1416 17.4585 12.6166 17.6752 11.9999 17.6752C11.3666 17.6752 10.8376 17.4585 10.4129 17.0252C9.98757 16.5919 9.7749 16.0752 9.7749 15.4752C9.7749 14.9919 9.91257 14.5752 10.1879 14.2252C10.4626 13.8752 11.0666 13.1585 11.9999 12.0752C12.9166 13.1585 13.5166 13.8752 13.7999 14.2252C14.0832 14.5752 14.2249 14.9919 14.2249 15.4752C14.2249 16.0752 14.0082 16.5919 13.5749 17.0252Z',
        },
        {
          d: 'M1 14L3 14L3 10L1 10L1 14Z',
        },
        {
          d: 'M21 14L23 14L23 10L21 10L21 14Z',
        },
      ],
    },
    'emmaTreeNode-air': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 21.5C10.6833 21.5 9.446 21.25 8.288 20.75C7.12933 20.25 6.125 19.575 5.275 18.725C4.425 17.875 3.75 16.8707 3.25 15.712C2.75 14.554 2.5 13.3167 2.5 12C2.5 10.6833 2.75 9.44567 3.25 8.287C3.75 7.129 4.425 6.125 5.275 5.275C6.125 4.425 7.12933 3.75 8.288 3.25C9.446 2.75 10.6833 2.5 12 2.5C13.3167 2.5 14.5543 2.75 15.713 3.25C16.871 3.75 17.875 4.425 18.725 5.275C19.575 6.125 20.25 7.129 20.75 8.287C21.25 9.44567 21.5 10.6833 21.5 12C21.5 13.3167 21.25 14.554 20.75 15.712C20.25 16.8707 19.575 17.875 18.725 18.725C17.875 19.575 16.871 20.25 15.713 20.75C14.5543 21.25 13.3167 21.5 12 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z',
        },
        {
          d: 'M17.1265 5.81305L15.7123 7.22726L16.773 8.28792L18.1872 6.87371L17.1265 5.81305Z',
        },
        {
          d: 'M16.773 15.7125L15.7123 16.7732L17.1265 18.1874L18.1872 17.1268L16.773 15.7125Z',
        },
        {
          d: 'M7.22703 15.7125L5.81282 17.1268L6.87348 18.1874L8.28769 16.7732L7.22703 15.7125Z',
        },
        {
          d: 'M6.87348 5.81305L5.81282 6.87371L7.22703 8.28792L8.28769 7.22726L6.87348 5.81305Z',
        },
        {
          d: 'M20 11.25L18 11.25L18 12.75L20 12.75L20 11.25Z',
        },
        {
          d: 'M6 11.25L4 11.25L4 12.75L6 12.75L6 11.25Z',
        },
        {
          d: 'M12.75 4L11.25 4L11.25 6L12.75 6L12.75 4Z',
        },
        {
          d: 'M14 23L14 21L10 21L10 23L14 23Z',
        },
        {
          d: 'M12 14C11.7228 14 11.4623 13.9474 11.2185 13.8421C10.9746 13.7368 10.7632 13.5947 10.5842 13.4158C10.4053 13.2368 10.2632 13.0254 10.1579 12.7815C10.0526 12.5377 10 12.2772 10 12C10 11.7228 10.0526 11.4622 10.1579 11.2183C10.2632 10.9745 10.4053 10.7632 10.5842 10.5842C10.7632 10.4053 10.9746 10.2632 11.2185 10.1579C11.4623 10.0526 11.7228 10 12 10C12.2772 10 12.5378 10.0526 12.7817 10.1579C13.0255 10.2632 13.2368 10.4053 13.4158 10.5842C13.5947 10.7632 13.7368 10.9745 13.8421 11.2183C13.9474 11.4622 14 11.7228 14 12C14 12.2772 13.9474 12.5377 13.8421 12.7815C13.7368 13.0254 13.5947 13.2368 13.4158 13.4158C13.2368 13.5947 13.0255 13.7368 12.7817 13.8421C12.5378 13.9474 12.2772 14 12 14Z',
        },
        {
          d: 'M15.8198 8.14993L10.9484 10.991L12.9788 13.0213L15.8198 8.14993Z',
        },
      ],
    },
    'emmaTreeNode-heat': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.4701 18.06C10.4401 18.06 9.54012 17.72 8.77012 17.05C8.00012 16.37 7.62012 15.5 7.62012 14.44C7.62012 14.07 7.67012 13.7 7.78012 13.33C7.89012 12.96 8.08012 12.59 8.34012 12.24C8.37012 12.19 8.41012 12.15 8.46012 12.12C8.51012 12.09 8.58012 12.07 8.66012 12.07C8.69012 12.07 8.72012 12.08 8.75012 12.11C8.77012 12.14 8.79012 12.16 8.79012 12.2C8.77012 12.27 8.76012 12.37 8.74012 12.51C8.72012 12.65 8.72012 12.78 8.72012 12.9C8.72012 13.38 8.82012 13.8 9.03012 14.14C9.24012 14.48 9.45012 14.65 9.67012 14.65C9.82012 14.65 9.94012 14.6 10.0501 14.49C10.1501 14.38 10.2001 14.24 10.2001 14.08C10.2001 13.96 10.1801 13.85 10.1501 13.73C10.1201 13.61 10.0801 13.47 10.0501 13.3C10.0001 13.15 9.96012 12.98 9.93012 12.79C9.90012 12.6 9.88012 12.38 9.88012 12.13C9.88012 11.33 10.2001 10.58 10.6001 10.08C10.8444 9.77462 11.3801 9.36996 12.0701 9.04996L12.1401 9.00996C12.1401 9.00996 12.1801 8.99996 12.2101 8.99996C12.2401 8.99996 12.2701 9.00996 12.2801 9.03996C12.3001 9.06996 12.3001 9.08996 12.2801 9.12996C12.2101 9.32996 12.1601 9.50996 12.1301 9.65996C12.1001 9.80996 12.0801 9.97996 12.0801 10.16C12.0801 10.71 12.3154 11.1972 12.6001 11.58C12.8456 11.91 13.2801 12.0272 13.6401 12.28C14.1101 12.61 14.4501 13.01 14.6601 13.48C14.8801 13.95 14.9801 14.43 14.9801 14.93C14.9801 15.73 14.6701 16.45 14.0501 17.11C13.4301 17.77 12.5701 18.09 11.4501 18.09L11.4701 18.06ZM11.5901 16.76C12.1101 16.76 12.5501 16.58 12.9301 16.24C13.3001 15.89 13.4901 15.47 13.4901 14.97C13.4901 14.65 13.4201 14.37 13.2801 14.13C13.1401 13.89 12.9401 13.68 12.6901 13.49C12.3901 13.27 12.1401 13.03 11.9401 12.76C11.7401 12.49 11.6201 12.21 11.5601 11.91C11.3801 12.14 11.2701 12.39 11.2401 12.64C11.2101 12.89 11.2401 13.19 11.3101 13.54C11.3601 13.74 11.3901 13.92 11.4101 14.08C11.4301 14.24 11.4401 14.38 11.4301 14.52C11.4301 15 11.2701 15.38 10.9401 15.64C10.6101 15.91 10.2601 16.02 9.88012 15.96C10.0601 16.21 10.3101 16.41 10.6201 16.55C10.9301 16.69 11.2501 16.76 11.5801 16.76H11.5901Z',
        },
        {
          d: 'M7.5 21C6.53 21 5.71 20.66 5.03 19.98C4.35 19.3 4 18.47 4 17.5L4 7.5C4 6.53 4.34 5.71 5.03 5.03C5.72 4.35 6.54 4 7.5 4L8.75 4L8.75 2L10.25 2L10.25 4L11.5 4L12.75 4L12.75 2L14.25 2L14.25 4L15.5 4C16.47 4 17.29 4.34 17.98 5.03C18.66 5.71 19 6.54 19 7.5L19 17.5C19 18.47 18.66 19.29 17.98 19.98C17.3 20.66 16.47 21 15.5 21L7.5 21ZM7.5 19.5L15.5 19.5C16.05 19.5 16.52 19.3 16.91 18.91C17.3 18.52 17.5 18.05 17.5 17.5L17.5 7.5C17.5 6.95 17.3 6.48 16.91 6.09C16.52 5.7 16.05 5.5 15.5 5.5L7.5 5.5C6.95 5.5 6.48 5.7 6.09 6.09C5.7 6.48 5.5 6.95 5.5 7.5L5.5 17.5C5.5 18.05 5.7 18.52 6.09 18.91C6.48 19.3 6.95 19.5 7.5 19.5ZM7.75 8.5L15.25 8.5L15.25 7L7.75 7L7.75 8.5Z',
        },
      ],
    },
    'emmaTreeNode-energy': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M16.5 2C17.47 2 18.29 2.34 18.97 3.02C19.65 3.7 20 4.53 20 5.5L20 15.5C20 16.47 19.66 17.29 18.97 17.97C18.28 18.65 17.46 19 16.5 19L15.25 19L13.75 19L12.5 19L11.25 19L9.75 19L8.5 19C7.53 19 6.71 18.66 6.02 17.97C5.34 17.29 5 16.46 5 15.5L5 5.5C5 4.53 5.34 3.71 6.02 3.02C6.7 2.34 7.53 2 8.5 2L16.5 2ZM16.5 3.5L8.5 3.5C7.95 3.5 7.48 3.7 7.09 4.09C6.7 4.48 6.5 4.95 6.5 5.5L6.5 15.5C6.5 16.05 6.7 16.52 7.09 16.91C7.48 17.3 7.95 17.5 8.5 17.5L16.5 17.5C17.05 17.5 17.52 17.3 17.91 16.91C18.3 16.52 18.5 16.05 18.5 15.5L18.5 5.5C18.5 4.95 18.3 4.48 17.91 4.09C17.52 3.7 17.05 3.5 16.5 3.5ZM16.25 5.5L8.75 5.5L8.75 7L16.25 7L16.25 5.5Z',
        },
        {
          d: 'M12.9839 8L10 12.8L12.0161 12.8L12.0161 16L13.5081 13.6L15 11.2L12.9839 11.2L12.9839 8Z',
        },
        {
          d: 'M10.75 19L10.75 21L9.25 21L9.25 19L10.75 19Z',
        },
        {
          d: 'M13.25 19L13.25 21L11.75 21L11.75 19L13.25 19Z',
        },
        {
          d: 'M15.75 19L15.75 21L14.25 21L14.25 19L15.75 19Z',
        },
      ],
    },
    'emmaTreeNode-energy-multiple': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M4.3 21.4996C3.8 21.4996 3.375 21.3246 3.025 20.9746C2.675 20.6246 2.5 20.1996 2.5 19.6996V10.2996C2.5 9.79961 2.675 9.37461 3.025 9.02461C3.375 8.67461 3.8 8.49961 4.3 8.49961H19.7C20.2 8.49961 20.625 8.67461 20.975 9.02461C21.325 9.37461 21.5 9.79961 21.5 10.2996V19.6996C21.5 20.1996 21.325 20.6246 20.975 20.9746C20.625 21.3246 20.2 21.4996 19.7 21.4996H4.3ZM4.3 19.9996H19.7C19.7667 19.9996 19.8333 19.9663 19.9 19.8996C19.9667 19.8329 20 19.7663 20 19.6996V10.2996C20 10.2329 19.9667 10.1663 19.9 10.0996C19.8333 10.0329 19.7667 9.99961 19.7 9.99961H4.3C4.23333 9.99961 4.16667 10.0329 4.1 10.0996C4.03333 10.1663 4 10.2329 4 10.2996V19.6996C4 19.7663 4.03333 19.8329 4.1 19.8996C4.16667 19.9663 4.23333 19.9996 4.3 19.9996ZM4.25 7.12461V5.62461H19.75V7.12461H4.25ZM7.25 4.22461V2.72461H16.75V4.22461H7.25Z',
        },
        {
          d: 'M7.375 14.7246L12.925 17.4996V15.6246H16.625L11.075 12.8496V14.7246H7.375Z',
        },
        {
          d: 'M1 15.9996V17.4996H4V15.9996H1Z',
        },
        {
          d: 'M1 12.3746V13.8746H4V12.3746H1Z',
        },
      ],
    },
    'emmaTreeNode-tree': {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M15.25 20.75V17.75H11.25V7.75H8.75V10.75H2.25V3.25H8.75V6.25H15.25V3.25H21.75V10.75H15.25V7.75H12.75V16.25H15.25V13.25H21.75V20.75H15.25ZM3.75 4.75V9.25V4.75ZM16.75 14.75V19.25V14.75ZM16.75 4.75V9.25V4.75ZM16.75 9.25H20.25V4.75H16.75V9.25ZM16.75 19.25H20.25V14.75H16.75V19.25ZM3.75 9.25H7.25V4.75H3.75V9.25Z',
        },
      ],
    },
    emmaAddMetric: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.2222 19H12.7778V13H11.2222V19ZM5 19H6.55556V13H5V19ZM17.4444 19H19V13H17.4444V19Z',
        },
        {
          d: 'M9.66667 19H8.11111V10H9.66667V19Z',
        },
        {
          d: 'M14.3333 19H15.8889V10H14.3333V19Z',
        },
        {
          d: 'M19 4H17.5V7H14.5V8.5H17.5V11.5H19V8.5H22V7H19V4Z',
        },
      ],
    },
    emmaAddData: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M8.30765 19.0768H5.53845C4.28282 19.0768 3.2125 18.6344 2.3275 17.7495C1.4425 16.8646 1 15.7945 1 14.539C1 13.2835 1.4425 12.2131 2.3275 11.3279C3.2125 10.4426 4.28282 10 5.53845 10H8.30765V11.4999H5.53845C4.6987 11.4999 3.98235 11.7964 3.3894 12.3894C2.79645 12.9823 2.49998 13.6987 2.49998 14.5384C2.49998 15.3782 2.79645 16.0945 3.3894 16.6875C3.98235 17.2804 4.6987 17.5769 5.53845 17.5769H8.30765V19.0768ZM6.75 15.2884V13.7885H12.25V15.2884H6.75ZM10.6923 19.0768V17.5769H13.4615C14.3013 17.5769 15.0176 17.2804 15.6106 16.6875C16.2035 16.0945 16.5 15.3782 16.5 14.5384C16.5 13.6987 16.2035 12.9823 15.6106 12.3894C15.0176 11.7964 14.3013 11.4999 13.4615 11.4999H10.6923V10H13.4615C14.7171 10 15.7875 10.4424 16.6725 11.3273C17.5575 12.2122 18 13.2824 18 14.5379C18 15.7934 17.5575 16.8637 16.6725 17.749C15.7875 18.6342 14.7171 19.0768 13.4615 19.0768H10.6923Z',
        },
        {
          d: 'M19 4H17.5V7H14.5V8.5H17.5V11.5H19V8.5H22V7H19V4Z',
        },
      ],
    },
    expandIcon: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M4 2H2V22H4V13H18.17L12.67 18.5L14.08 19.92L22 12L14.08 4.08L12.67 5.5L18.17 11H4V2Z',
        },
      ],
    },
    expandMapIcon: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41z',
        },
        {
          d: 'M20 6v12h2V6h-2z',
        },
      ],
    },
    accountGroupIcon: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 5.5C12.9283 5.5 13.8185 5.86875 14.4749 6.52513C15.1313 7.1815 15.5 8.07174 15.5 9C15.5 9.92826 15.1313 10.8185 14.4749 11.4749C13.8185 12.1313 12.9283 12.5 12 12.5C11.0717 12.5 10.1815 12.1313 9.52513 11.4749C8.86875 10.8185 8.5 9.92826 8.5 9C8.5 8.07174 8.86875 7.1815 9.52513 6.52513C10.1815 5.86875 11.0717 5.5 12 5.5ZM5 8C5.56 8 6.08 8.15 6.53 8.42C6.38 9.85 6.8 11.27 7.66 12.38C7.16 13.34 6.16 14 5 14C4.20435 14 3.44129 13.6839 2.87868 13.1213C2.31607 12.5587 2 11.7956 2 11C2 10.2044 2.31607 9.44129 2.87868 8.87868C3.44129 8.31607 4.20435 8 5 8ZM19 8C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11C22 11.7956 21.6839 12.5587 21.1213 13.1213C20.5587 13.6839 19.7956 14 19 14C17.84 14 16.84 13.34 16.34 12.38C17.2 11.27 17.62 9.85 17.47 8.42C17.92 8.15 18.44 8 19 8ZM5.5 18.25C5.5 16.18 8.41 14.5 12 14.5C15.59 14.5 18.5 16.18 18.5 18.25V20H5.5V18.25ZM0 20V18.5C0 17.11 1.89 15.94 4.45 15.6C3.86 16.28 3.5 17.22 3.5 18.25V20H0ZM24 20H20.5V18.25C20.5 17.22 20.14 16.28 19.55 15.6C22.11 15.94 24 17.11 24 18.5V20Z',
        },
      ],
    },
    lockLocked: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M12 17C12.3956 17 12.7822 16.8827 13.1111 16.6629C13.44 16.4432 13.6964 16.1308 13.8478 15.7654C13.9991 15.3999 14.0387 14.9978 13.9616 14.6098C13.8844 14.2219 13.6939 13.8655 13.4142 13.5858C13.1345 13.3061 12.7781 13.1156 12.3902 13.0384C12.0022 12.9613 11.6001 13.0009 11.2346 13.1522C10.8692 13.3036 10.5568 13.56 10.3371 13.8889C10.1173 14.2178 10 14.6044 10 15C10 15.5304 10.2107 16.0391 10.5858 16.4142C10.9609 16.7893 11.4696 17 12 17ZM18 8C18.5304 8 19.0391 8.21071 19.4142 8.58579C19.7893 8.96086 20 9.46957 20 10V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V10C4 9.46957 4.21071 8.96086 4.58579 8.58579C4.96086 8.21071 5.46957 8 6 8H7V6C7 4.67392 7.52678 3.40215 8.46447 2.46447C9.40215 1.52678 10.6739 1 12 1C13.3261 1 14.5979 1.52678 15.5355 2.46447C16.4732 3.40215 17 4.67392 17 6V8H18ZM12 3C11.2044 3 10.4413 3.31607 9.87868 3.87868C9.31607 4.44129 9 5.20435 9 6V8H15V6C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3Z',
        },
      ],
    },
    lockUnlocked: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M18 8C18.5304 8 19.0391 8.21071 19.4142 8.58579C19.7893 8.96086 20 9.46957 20 10V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V10C4 9.46957 4.21071 8.96086 4.58579 8.58579C4.96086 8.21071 5.46957 8 6 8H15V6C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3C11.2044 3 10.4413 3.31607 9.87868 3.87868C9.31607 4.44129 9 5.20435 9 6H7C7 4.67392 7.52678 3.40215 8.46447 2.46447C9.40215 1.52678 10.6739 1 12 1C13.3261 1 14.5979 1.52678 15.5355 2.46447C16.4732 3.40215 17 4.67392 17 6V8H18ZM12 17C12.3956 17 12.7822 16.8827 13.1111 16.6629C13.44 16.4432 13.6964 16.1308 13.8478 15.7654C13.9991 15.3999 14.0387 14.9978 13.9616 14.6098C13.8844 14.2219 13.6939 13.8655 13.4142 13.5858C13.1345 13.3061 12.7781 13.1156 12.3902 13.0384C12.0022 12.9613 11.6001 13.0009 11.2346 13.1522C10.8692 13.3036 10.5568 13.56 10.3371 13.8889C10.1173 14.2178 10 14.6044 10 15C10 15.5304 10.2107 16.0391 10.5858 16.4142C10.9609 16.7893 11.4696 17 12 17Z',
        },
      ],
    },
    charted: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
        },
      ],
    },
    sidePanel: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M4.3 19.5C3.8 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.2 2.5 17.7V6.3C2.5 5.8 2.675 5.375 3.025 5.025C3.375 4.675 3.8 4.5 4.3 4.5H19.7C20.2 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.8 21.5 6.3V17.7C21.5 18.2 21.325 18.625 20.975 18.975C20.625 19.325 20.2 19.5 19.7 19.5H4.3ZM4.3 18H10.25V6H4.3C4.23333 6 4.16667 6.03333 4.1 6.1C4.03333 6.16667 4 6.23333 4 6.3V17.7C4 17.7667 4.03333 17.8333 4.1 17.9C4.16667 17.9667 4.23333 18 4.3 18ZM11.75 18H19.7C19.7667 18 19.8333 17.9667 19.9 17.9C19.9667 17.8333 20 17.7667 20 17.7V6.3C20 6.23333 19.9667 6.16667 19.9 6.1C19.8333 6.03333 19.7667 6 19.7 6H11.75V18Z',
        },
        {
          d: 'M5.25 14.625V13.125H8.75V14.625H5.25ZM5.25 11.75V10.25H8.75V11.75H5.25ZM5.25 8.875V7.375H8.75V8.875H5.25Z',
        },
      ],
    },
    tabulated: {
      viewBox: '14 14 24 24',
      paths: [
        {
          d: 'M18.5 34.5V17.5H35.5V34.5H18.5ZM20 23.075H34V19H20V23.075ZM25.15 28.05H28.85V24.575H25.15V28.05ZM25.15 33H28.85V29.55H25.15V33ZM20 28.05H23.65V24.575H20V28.05ZM30.35 28.05H34V24.575H30.35V28.05ZM20 33H23.65V29.55H20V33ZM30.35 33H34V29.55H30.35V33Z',
        },
        {
          d: 'M53.25 33.75V23.25H56.7499V33.75H53.25ZM59.25 33.75V18.25H62.75V33.75H59.25ZM65.25 33.75V27.25H68.75V33.75H65.25Z',
        },
        {
          d: 'M86.5001 32.1539L85.3848 31.0386L92.5386 23.8848L96.5386 27.8848L103.581 19.8848L104.635 20.9193L96.5578 30.1347L92.5386 26.1155L86.5001 32.1539Z',
        },
        {
          d: 'M129.75 25.25H136.969C136.777 23.3205 136.008 21.6814 134.662 20.3327C133.317 18.9839 131.679 18.2166 129.75 18.0308V25.25ZM128.25 33.9692V18.0308C126.188 18.2166 124.465 19.0702 123.079 20.5913C121.693 22.1125 121 23.9154 121 26C121 28.0846 121.693 29.8875 123.079 31.4086C124.465 32.9298 126.188 33.7833 128.25 33.9692ZM129.75 33.9692C131.679 33.7936 133.32 33.0288 134.67 31.675C136.021 30.3211 136.787 28.6795 136.969 26.75H129.75V33.9692ZM129.002 35.5C127.688 35.5 126.453 35.2506 125.297 34.752C124.14 34.2533 123.135 33.5765 122.28 32.7217C121.424 31.8669 120.747 30.8616 120.248 29.706C119.749 28.5504 119.5 27.3156 119.5 26.0017C119.5 24.6877 119.749 23.4527 120.248 22.2966C120.747 21.1404 121.423 20.1347 122.278 19.2795C123.133 18.4243 124.138 17.7472 125.294 17.2483C126.45 16.7494 127.684 16.5 128.998 16.5C130.312 16.5 131.545 16.7497 132.695 17.2491C133.846 17.7484 134.851 18.4282 135.712 19.2885C136.572 20.1487 137.252 21.1538 137.751 22.3036C138.25 23.4535 138.5 24.6866 138.5 26.003C138.5 27.3036 138.251 28.5313 137.752 29.6861C137.253 30.841 136.577 31.8495 135.722 32.7117C134.867 33.5739 133.862 34.2541 132.706 34.7525C131.55 35.2508 130.316 35.5 129.002 35.5Z',
        },
        {
          d: 'M154 19V17H157V19H154ZM159 19V17H162V19H159ZM164 19V17H167V19H164ZM169 19V17H172V19H169Z',
        },
        {
          d: 'M154 27V25H157V27H154ZM154 23V21H157V23H154ZM159 27V25H162V27H159ZM159 23V21H162V23H159ZM164 27V25H167V27H164ZM164 23V21H167V23H164ZM169 27V25H172V27H169ZM169 23V21H172V23H169Z',
        },
        {
          d: 'M154 35V33H157V35H154ZM154 31V29H157V31H154ZM159 35V33H162V35H159ZM159 31V29H162V31H159ZM164 35V33H167V35H164ZM164 31V29H167V31H164ZM169 35V33H172V35H169ZM169 31V29H172V31H169Z',
        },
      ],
    },
    electricity: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7 22L11 14.5L3 13.5L15 2H17L13 9.5L21 10.5L9 22H7ZM12.55 15.825L16.575 11.975L9.85 11.125L11.425 8.2L7.425 12.05L14.125 12.875L12.55 15.825Z',
        },
      ],
    },
    air: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M11.5 20C10.6667 20 9.95833 19.7083 9.375 19.125C8.79167 18.5417 8.5 17.8333 8.5 17H10.5C10.5 17.2833 10.5958 17.5208 10.7875 17.7125C10.9792 17.9042 11.2167 18 11.5 18C11.7833 18 12.0208 17.9042 12.2125 17.7125C12.4042 17.5208 12.5 17.2833 12.5 17C12.5 16.7167 12.4042 16.4792 12.2125 16.2875C12.0208 16.0958 11.7833 16 11.5 16H2V14H11.5C12.3333 14 13.0417 14.2917 13.625 14.875C14.2083 15.4583 14.5 16.1667 14.5 17C14.5 17.8333 14.2083 18.5417 13.625 19.125C13.0417 19.7083 12.3333 20 11.5 20ZM2 10V8H15.5C15.9333 8 16.2917 7.85833 16.575 7.575C16.8583 7.29167 17 6.93333 17 6.5C17 6.06667 16.8583 5.70833 16.575 5.425C16.2917 5.14167 15.9333 5 15.5 5C15.0667 5 14.7083 5.14167 14.425 5.425C14.1417 5.70833 14 6.06667 14 6.5H12C12 5.51667 12.3375 4.6875 13.0125 4.0125C13.6875 3.3375 14.5167 3 15.5 3C16.4833 3 17.3125 3.3375 17.9875 4.0125C18.6625 4.6875 19 5.51667 19 6.5C19 7.48333 18.6625 8.3125 17.9875 8.9875C17.3125 9.6625 16.4833 10 15.5 10H2ZM18.5 18V16C18.9333 16 19.2917 15.8583 19.575 15.575C19.8583 15.2917 20 14.9333 20 14.5C20 14.0667 19.8583 13.7083 19.575 13.425C19.2917 13.1417 18.9333 13 18.5 13H2V11H18.5C19.4833 11 20.3125 11.3375 20.9875 12.0125C21.6625 12.6875 22 13.5167 22 14.5C22 15.4833 21.6625 16.3125 20.9875 16.9875C20.3125 17.6625 19.4833 18 18.5 18Z',
        },
      ],
    },
    water: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M2 18V16C2.63333 16 3.10417 15.8333 3.4125 15.5C3.72083 15.1667 4.36667 15 5.35 15C6.33333 15 6.97917 15.1667 7.2875 15.5C7.59583 15.8333 8.05 16 8.65 16C9.28333 16 9.75417 15.8333 10.0625 15.5C10.3708 15.1667 11.0167 15 12 15C12.95 15 13.5958 15.1667 13.9375 15.5C14.2792 15.8333 14.75 16 15.35 16C15.9833 16 16.4458 15.8333 16.7375 15.5C17.0292 15.1667 17.6667 15 18.65 15C19.6333 15 20.2792 15.1667 20.5875 15.5C20.8958 15.8333 21.3667 16 22 16V18C21.05 18 20.4042 17.8333 20.0625 17.5C19.7208 17.1667 19.25 17 18.65 17C18.05 17 17.5958 17.1667 17.2875 17.5C16.9792 17.8333 16.3333 18 15.35 18C14.4 18 13.7542 17.8333 13.4125 17.5C13.0708 17.1667 12.6 17 12 17C11.3667 17 10.8958 17.1667 10.5875 17.5C10.2792 17.8333 9.63333 18 8.65 18C7.66667 18 7.02917 17.8333 6.7375 17.5C6.44583 17.1667 5.98333 17 5.35 17C4.71667 17 4.24583 17.1667 3.9375 17.5C3.62917 17.8333 2.98333 18 2 18ZM2 14V12C2.63333 12 3.10417 11.8333 3.4125 11.5C3.72083 11.1667 4.36667 11 5.35 11C6.3 11 6.9375 11.1667 7.2625 11.5C7.5875 11.8333 8.05 12 8.65 12C9.28333 12 9.75417 11.8333 10.0625 11.5C10.3708 11.1667 11.0167 11 12 11C12.95 11 13.5917 11.1667 13.925 11.5C14.2583 11.8333 14.7167 12 15.3 12C15.9333 12 16.4042 11.8333 16.7125 11.5C17.0208 11.1667 17.6667 11 18.65 11C19.6 11 20.2458 11.1667 20.5875 11.5C20.9292 11.8333 21.4 12 22 12V14C21.0167 14 20.3625 13.8333 20.0375 13.5C19.7125 13.1667 19.25 13 18.65 13C18.05 13 17.5958 13.1667 17.2875 13.5C16.9792 13.8333 16.3333 14 15.35 14C14.4 14 13.7542 13.8333 13.4125 13.5C13.0708 13.1667 12.6 13 12 13C11.3667 13 10.9042 13.1667 10.6125 13.5C10.3208 13.8333 9.68333 14 8.7 14C7.71667 14 7.0625 13.8333 6.7375 13.5C6.4125 13.1667 5.95 13 5.35 13C4.75 13 4.27917 13.1667 3.9375 13.5C3.59583 13.8333 2.95 14 2 14ZM2 10V8C2.63333 8 3.10417 7.83333 3.4125 7.5C3.72083 7.16667 4.36667 7 5.35 7C6.3 7 6.9375 7.16667 7.2625 7.5C7.5875 7.83333 8.05 8 8.65 8C9.28333 8 9.75417 7.83333 10.0625 7.5C10.3708 7.16667 11.0167 7 12 7C12.95 7 13.5917 7.16667 13.925 7.5C14.2583 7.83333 14.7167 8 15.3 8C15.9333 8 16.4042 7.83333 16.7125 7.5C17.0208 7.16667 17.6667 7 18.65 7C19.6 7 20.2458 7.16667 20.5875 7.5C20.9292 7.83333 21.4 8 22 8V10C21.0167 10 20.3625 9.83333 20.0375 9.5C19.7125 9.16667 19.25 9 18.65 9C18.05 9 17.5958 9.16667 17.2875 9.5C16.9792 9.83333 16.3333 10 15.35 10C14.4 10 13.7542 9.83333 13.4125 9.5C13.0708 9.16667 12.6 9 12 9C11.3667 9 10.9042 9.16667 10.6125 9.5C10.3208 9.83333 9.68333 10 8.7 10C7.71667 10 7.0625 9.83333 6.7375 9.5C6.4125 9.16667 5.95 9 5.35 9C4.75 9 4.27917 9.16667 3.9375 9.5C3.59583 9.83333 2.95 10 2 10Z',
        },
      ],
    },
    gas: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M6 14C6 14.8667 6.175 15.6875 6.525 16.4625C6.875 17.2375 7.375 17.9167 8.025 18.5C8.00833 18.4167 8 18.3417 8 18.275V18.05C8 17.5167 8.1 17.0167 8.3 16.55C8.5 16.0833 8.79167 15.6583 9.175 15.275L12 12.5L14.825 15.275C15.2083 15.6583 15.5 16.0833 15.7 16.55C15.9 17.0167 16 17.5167 16 18.05V18.275C16 18.3417 15.9917 18.4167 15.975 18.5C16.625 17.9167 17.125 17.2375 17.475 16.4625C17.825 15.6875 18 14.8667 18 14C18 13.1667 17.8458 12.3792 17.5375 11.6375C17.2292 10.8958 16.7833 10.2333 16.2 9.65C15.8667 9.86667 15.5167 10.0292 15.15 10.1375C14.7833 10.2458 14.4083 10.3 14.025 10.3C12.9917 10.3 12.0958 9.95833 11.3375 9.275C10.5792 8.59167 10.1417 7.75 10.025 6.75C9.375 7.3 8.8 7.87083 8.3 8.4625C7.8 9.05417 7.37917 9.65417 7.0375 10.2625C6.69583 10.8708 6.4375 11.4917 6.2625 12.125C6.0875 12.7583 6 13.3833 6 14ZM12 15.3L10.575 16.7C10.3917 16.8833 10.25 17.0917 10.15 17.325C10.05 17.5583 10 17.8 10 18.05C10 18.5833 10.1958 19.0417 10.5875 19.425C10.9792 19.8083 11.45 20 12 20C12.55 20 13.0208 19.8083 13.4125 19.425C13.8042 19.0417 14 18.5833 14 18.05C14 17.7833 13.95 17.5375 13.85 17.3125C13.75 17.0875 13.6083 16.8833 13.425 16.7L12 15.3ZM12 3V6.3C12 6.86667 12.1958 7.34167 12.5875 7.725C12.9792 8.10833 13.4583 8.3 14.025 8.3C14.325 8.3 14.6042 8.2375 14.8625 8.1125C15.1208 7.9875 15.35 7.8 15.55 7.55L16 7C17.2333 7.7 18.2083 8.675 18.925 9.925C19.6417 11.175 20 12.5333 20 14C20 16.2333 19.225 18.125 17.675 19.675C16.125 21.225 14.2333 22 12 22C9.76667 22 7.875 21.225 6.325 19.675C4.775 18.125 4 16.2333 4 14C4 11.85 4.72083 9.80833 6.1625 7.875C7.60417 5.94167 9.55 4.31667 12 3Z',
        },
      ],
    },
    steam: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M13.3 20.725C13.2 20.8083 13.0958 20.875 12.9875 20.925C12.8792 20.975 12.7583 21 12.625 21C12.4917 21 12.3583 20.9708 12.225 20.9125C12.0917 20.8542 11.975 20.775 11.875 20.675C11.1917 19.9417 10.6875 19.1917 10.3625 18.425C10.0375 17.6583 9.875 16.85 9.875 16C9.875 15.3833 9.96667 14.7333 10.15 14.05C10.3333 13.3667 10.65 12.4833 11.1 11.4C11.4833 10.45 11.75 9.72083 11.9 9.2125C12.05 8.70417 12.125 8.23333 12.125 7.8C12.125 7.23333 12 6.70417 11.75 6.2125C11.5 5.72083 11.1083 5.225 10.575 4.725C10.475 4.625 10.3958 4.50833 10.3375 4.375C10.2792 4.24167 10.25 4.10833 10.25 3.975C10.25 3.84167 10.275 3.72083 10.325 3.6125C10.375 3.50417 10.4417 3.4 10.525 3.3C10.625 3.2 10.7375 3.125 10.8625 3.075C10.9875 3.025 11.1167 3 11.25 3C11.3833 3 11.5083 3.025 11.625 3.075C11.7417 3.125 11.85 3.19167 11.95 3.275C12.6833 3.95833 13.2292 4.675 13.5875 5.425C13.9458 6.175 14.125 6.96667 14.125 7.8C14.125 8.38333 14.0375 8.99583 13.8625 9.6375C13.6875 10.2792 13.3833 11.1167 12.95 12.15C12.5333 13.15 12.25 13.9167 12.1 14.45C11.95 14.9833 11.875 15.4917 11.875 15.975C11.875 16.5583 11.9958 17.1208 12.2375 17.6625C12.4792 18.2042 12.85 18.75 13.35 19.3C13.4333 19.4 13.5 19.5083 13.55 19.625C13.6 19.7417 13.625 19.8667 13.625 20C13.625 20.1333 13.6 20.2625 13.55 20.3875C13.5 20.5125 13.4167 20.625 13.3 20.725ZM18.175 20.725C18.075 20.8083 17.9708 20.875 17.8625 20.925C17.7542 20.975 17.6333 21 17.5 21C17.3667 21 17.2333 20.9708 17.1 20.9125C16.9667 20.8542 16.85 20.775 16.75 20.675C16.0667 19.9417 15.5625 19.1958 15.2375 18.4375C14.9125 17.6792 14.75 16.875 14.75 16.025C14.75 15.4083 14.8417 14.75 15.025 14.05C15.2083 13.35 15.525 12.4667 15.975 11.4C16.3583 10.45 16.625 9.725 16.775 9.225C16.925 8.725 17 8.25833 17 7.825C17 7.25833 16.875 6.72083 16.625 6.2125C16.375 5.70417 15.9833 5.20833 15.45 4.725C15.35 4.625 15.275 4.5125 15.225 4.3875C15.175 4.2625 15.15 4.13333 15.15 4C15.15 3.86667 15.1708 3.74583 15.2125 3.6375C15.2542 3.52917 15.3167 3.425 15.4 3.325C15.5 3.225 15.6167 3.14583 15.75 3.0875C15.8833 3.02917 16.0167 3 16.15 3C16.2833 3 16.4042 3.025 16.5125 3.075C16.6208 3.125 16.725 3.19167 16.825 3.275C17.5583 3.95833 18.1042 4.675 18.4625 5.425C18.8208 6.175 19 6.96667 19 7.8C19 8.38333 18.9125 8.99583 18.7375 9.6375C18.5625 10.2792 18.2583 11.125 17.825 12.175C17.4083 13.175 17.125 13.9417 16.975 14.475C16.825 15.0083 16.75 15.5083 16.75 15.975C16.75 16.5583 16.875 17.1292 17.125 17.6875C17.375 18.2458 17.75 18.7917 18.25 19.325C18.3333 19.425 18.3958 19.5333 18.4375 19.65C18.4792 19.7667 18.5 19.8833 18.5 20C18.5 20.1333 18.475 20.2667 18.425 20.4C18.375 20.5333 18.2917 20.6417 18.175 20.725ZM8.425 20.725C8.325 20.8083 8.22083 20.875 8.1125 20.925C8.00417 20.975 7.88333 21 7.75 21C7.61667 21 7.48333 20.9708 7.35 20.9125C7.21667 20.8542 7.1 20.775 7 20.675C6.31667 19.9417 5.8125 19.1958 5.4875 18.4375C5.1625 17.6792 5 16.875 5 16.025C5 15.4083 5.09167 14.75 5.275 14.05C5.45833 13.35 5.775 12.4667 6.225 11.4C6.60833 10.45 6.875 9.725 7.025 9.225C7.175 8.725 7.25 8.25833 7.25 7.825C7.25 7.25833 7.125 6.72083 6.875 6.2125C6.625 5.70417 6.23333 5.20833 5.7 4.725C5.58333 4.625 5.5 4.5125 5.45 4.3875C5.4 4.2625 5.375 4.13333 5.375 4C5.375 3.86667 5.4 3.74167 5.45 3.625C5.5 3.50833 5.56667 3.4 5.65 3.3C5.75 3.2 5.8625 3.125 5.9875 3.075C6.1125 3.025 6.24167 3 6.375 3C6.50833 3 6.63333 3.025 6.75 3.075C6.86667 3.125 6.975 3.19167 7.075 3.275C7.80833 3.95833 8.35417 4.67083 8.7125 5.4125C9.07083 6.15417 9.25 6.95 9.25 7.8C9.25 8.38333 9.16667 8.99583 9 9.6375C8.83333 10.2792 8.53333 11.1167 8.1 12.15C7.68333 13.15 7.4 13.9167 7.25 14.45C7.1 14.9833 7.025 15.4917 7.025 15.975C7.025 16.5583 7.14583 17.1292 7.3875 17.6875C7.62917 18.2458 8 18.7917 8.5 19.325C8.58333 19.425 8.64583 19.5333 8.6875 19.65C8.72917 19.7667 8.75 19.8833 8.75 20C8.75 20.1333 8.725 20.2667 8.675 20.4C8.625 20.5333 8.54167 20.6417 8.425 20.725Z',
        },
      ],
    },
    coldThermal: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M9.00758 12.0102L9.0125 12.0166V12.0002V6.00024C9.0125 5.17019 9.30288 4.46505 9.88384 3.88408C10.4648 3.30312 11.1699 3.01274 12 3.01274C12.8301 3.01274 13.5352 3.30312 14.1162 3.88408C14.6971 4.46505 14.9875 5.17019 14.9875 6.00024V12.0002H14.9794L14.9924 12.0102C15.6243 12.4924 16.1147 13.0785 16.4638 13.7684C16.8129 14.4582 16.9875 15.2021 16.9875 16.0002C16.9875 17.3803 16.5013 18.5563 15.5287 19.5289C14.556 20.5016 13.38 20.9877 12 20.9877C10.62 20.9877 9.44399 20.5016 8.47134 19.5289C7.49869 18.5563 7.0125 17.3803 7.0125 16.0002C7.0125 15.2021 7.18707 14.4582 7.53615 13.7684C7.88528 13.0785 8.37571 12.4924 9.00758 12.0102ZM12 19.0127C12.8366 19.0127 13.5481 18.7198 14.1338 18.1341C14.7195 17.5484 15.0125 16.8369 15.0125 16.0002C15.0125 15.515 14.9079 15.0631 14.6987 14.6447C14.4894 14.2262 14.1923 13.8747 13.8074 13.5902L13.0125 12.994V6.00024C13.0125 5.71376 12.9155 5.47303 12.7213 5.27891C12.5272 5.08478 12.2865 4.98774 12 4.98774C11.7135 4.98774 11.4728 5.08478 11.2787 5.27891C11.0845 5.47303 10.9875 5.71376 10.9875 6.00024V12.994L10.1926 13.5902C9.80769 13.8747 9.51056 14.2262 9.30132 14.6447C9.09209 15.0631 8.9875 15.515 8.9875 16.0002C8.9875 16.8369 9.28046 17.5484 9.86616 18.1341C10.4519 18.7198 11.1634 19.0127 12 19.0127Z',
        },
      ],
    },
    hotThermal: {
      viewBox: '4 4 24 24',
      paths: [
        {
          d: 'M13.0076 17.0102L13.0125 17.0166V17.0002V9.00024C13.0125 8.17019 13.3029 7.46505 13.8838 6.88408C14.4648 6.30312 15.1699 6.01274 16 6.01274C16.8301 6.01274 17.5352 6.30312 18.1162 6.88408C18.6971 7.46505 18.9875 8.17019 18.9875 9.00024V17.0002H18.9794L18.9924 17.0102C19.6243 17.4924 20.1147 18.0785 20.4638 18.7684C20.8129 19.4582 20.9875 20.2021 20.9875 21.0002C20.9875 22.3803 20.5013 23.5563 19.5287 24.5289C18.556 25.5016 17.38 25.9877 16 25.9877C14.62 25.9877 13.444 25.5016 12.4713 24.5289C11.4987 23.5563 11.0125 22.3803 11.0125 21.0002C11.0125 20.2021 11.1871 19.4582 11.5362 18.7684C11.8853 18.0785 12.3757 17.4924 13.0076 17.0102ZM14.9875 12.0002V12.0127H15H17H17.0125V12.0002V11.0002V10.9877H17H16.0125V10.0127H17H17.0125V10.0002V9.00024C17.0125 8.71376 16.9155 8.47303 16.7213 8.27891C16.5272 8.08478 16.2865 7.98774 16 7.98774C15.7135 7.98774 15.4728 8.08478 15.2787 8.27891C15.0845 8.47303 14.9875 8.71376 14.9875 9.00024V12.0002Z',
        },
      ],
    },
    cash: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M7 6.75C6.35185 6.75 5.80093 6.53125 5.34722 6.09375C4.89352 5.65625 4.66667 5.125 4.66667 4.5C4.66667 3.875 4.89352 3.34375 5.34722 2.90625C5.80093 2.46875 6.35185 2.25 7 2.25C7.64815 2.25 8.19907 2.46875 8.65278 2.90625C9.10648 3.34375 9.33333 3.875 9.33333 4.5C9.33333 5.125 9.10648 5.65625 8.65278 6.09375C8.19907 6.53125 7.64815 6.75 7 6.75ZM1.55556 9C1.12778 9 0.761574 8.85313 0.456945 8.55938C0.152315 8.26563 0 7.9125 0 7.5V1.5C0 1.0875 0.152315 0.734375 0.456945 0.440625C0.761574 0.146875 1.12778 0 1.55556 0H12.4444C12.8722 0 13.2384 0.146875 13.5431 0.440625C13.8477 0.734375 14 1.0875 14 1.5V7.5C14 7.9125 13.8477 8.26563 13.5431 8.55938C13.2384 8.85313 12.8722 9 12.4444 9H1.55556ZM3.11111 7.5H10.8889C10.8889 7.0875 11.0412 6.73438 11.3458 6.44063C11.6505 6.14688 12.0167 6 12.4444 6V3C12.0167 3 11.6505 2.85313 11.3458 2.55938C11.0412 2.26563 10.8889 1.9125 10.8889 1.5H3.11111C3.11111 1.9125 2.9588 2.26563 2.65417 2.55938C2.34954 2.85313 1.98333 3 1.55556 3V6C1.98333 6 2.34954 6.14688 2.65417 6.44063C2.9588 6.73438 3.11111 7.0875 3.11111 7.5Z',
        },
      ],
    },
    co2: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M8.5 6C8.21667 6 7.97917 5.90417 7.7875 5.7125C7.59583 5.52083 7.5 5.28333 7.5 5V1C7.5 0.716667 7.59583 0.479167 7.7875 0.2875C7.97917 0.0958333 8.21667 0 8.5 0H11.5C11.7833 0 12.0208 0.0958333 12.2125 0.2875C12.4042 0.479167 12.5 0.716667 12.5 1V5C12.5 5.28333 12.4042 5.52083 12.2125 5.7125C12.0208 5.90417 11.7833 6 11.5 6H8.5ZM9 4.5H11V1.5H9V4.5ZM1.5 6C1.21667 6 0.979167 5.90417 0.7875 5.7125C0.595833 5.52083 0.5 5.28333 0.5 5V1C0.5 0.716667 0.595833 0.479167 0.7875 0.2875C0.979167 0.0958333 1.21667 0 1.5 0H4.5C4.78333 0 5.02083 0.0958333 5.2125 0.2875C5.40417 0.479167 5.5 0.716667 5.5 1V2H4V1.5H2V4.5H4V4H5.5V5C5.5 5.28333 5.40417 5.52083 5.2125 5.7125C5.02083 5.90417 4.78333 6 4.5 6H1.5ZM14.5 9V6.5C14.5 6.21667 14.5958 5.97917 14.7875 5.7875C14.9792 5.59583 15.2167 5.5 15.5 5.5H17.5V4.5H14.5V3H18C18.2833 3 18.5208 3.09583 18.7125 3.2875C18.9042 3.47917 19 3.71667 19 4V5.5C19 5.78333 18.9042 6.02083 18.7125 6.2125C18.5208 6.40417 18.2833 6.5 18 6.5H16V7.5H19V9H14.5Z',
        },
      ],
    },
    fullscreen: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z',
        },
      ],
    },
    moveUp: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M9.00008 16.0002H7.00008V4.00016L1.50008 9.50016L0.0800781 8.08016L8.00008 0.160156L15.9201 8.08016L14.5001 9.50016L9.00008 4.00016V16.0002Z',
        },
      ],
    },
    moveDown: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M16 8L14.59 6.59L9 12.17V0H7V12.17L1.42 6.58L0 8L8 16L16 8Z',
        },
      ],
    },
    live: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M9.5 15.5L16.5 11L9.5 6.5V15.5ZM8 21V19H4C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H16V21H8ZM4 17H20V5H4V17Z',
        },
      ],
    },
    funnel: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M8.00002 16C7.71669 16 7.47919 15.9042 7.28752 15.7125C7.09585 15.5208 7.00002 15.2833 7.00002 15V9L1.20002 1.6C0.950019 1.26667 0.912519 0.916667 1.08752 0.55C1.26252 0.183333 1.56669 0 2.00002 0H16C16.4334 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9042 15.5208 10.7125 15.7125C10.5209 15.9042 10.2834 16 10 16H8.00002ZM9.00002 8.3L13.95 2H4.05002L9.00002 8.3Z',
        },
      ],
    },
    numerical: {
      viewBox: '0 -6 24 24',
      paths: [
        {
          d: 'M4.5 9H6V3H3V4.5H4.5V9ZM8 9H12.5V7.5H9.5V6.5H11.5C11.7833 6.5 12.0208 6.40417 12.2125 6.2125C12.4042 6.02083 12.5 5.78333 12.5 5.5V4C12.5 3.71667 12.4042 3.47917 12.2125 3.2875C12.0208 3.09583 11.7833 3 11.5 3H8V4.5H11V5.5H9C8.71667 5.5 8.47917 5.59583 8.2875 5.7875C8.09583 5.97917 8 6.21667 8 6.5V9ZM2 12C1.45 12 0.979167 11.8042 0.5875 11.4125C0.195833 11.0208 0 10.55 0 10V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H22C22.55 0 23.0208 0.195833 23.4125 0.5875C23.8042 0.979167 24 1.45 24 2V10C24 10.55 23.8042 11.0208 23.4125 11.4125C23.0208 11.8042 22.55 12 22 12H2ZM2 10H22V2H2V10Z',
        },
        {
          d: 'M17.5 9H14V7.5H17V6.5H15V5.5H17V4.5H14V3H17.5C17.7833 3 18.0208 3.09583 18.2125 3.2875C18.4042 3.47917 18.5 3.71667 18.5 4V8C18.5 8.28333 18.4042 8.52083 18.2125 8.7125C18.0208 8.90417 17.7833 9 17.5 9Z',
        },
      ],
    },
    barChart: {
      viewBox: '-4 -4 24 24',
      paths: [
        {
          d: 'M0.25 15.75V5.25H3.74995V15.75H0.25ZM6.25 15.75V0.25H9.74995V15.75H6.25ZM12.25 15.75V9.25H15.75V15.75H12.25Z',
        },
      ],
    },
    lineChart: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M3.50012 18.1539L2.38477 17.0386L9.53859 9.88477L13.5386 13.8848L20.5809 5.88477L21.6347 6.91934L13.5578 16.1347L9.53859 12.1155L3.50012 18.1539Z',
        },
      ],
    },
    loadDurationCurve: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M20.4999 18.1539H22C21.8302 17.6739 21.7453 17.4338 21.6546 17.2118C20.4926 14.3685 18.0885 12.217 15.1341 11.3764C14.9035 11.3108 14.6555 11.253 14.1596 11.1372L8.26636 9.76215C6.19715 9.27933 4.45024 7.90048 3.5 6H2C2.51905 7.0381 2.77858 7.55716 3.10217 8.00852C3.87022 9.07983 4.92515 9.9125 6.14556 10.4107C6.65974 10.6206 7.22488 10.7525 8.35515 11.0162L14.2382 12.3889C17.1927 13.0783 19.5693 15.2664 20.4999 18.1539Z',
        },
      ],
    },
    pieChart: {
      viewBox: '0 -2 24 24',
      paths: [
        {
          d: 'M10.75 9.25H17.9692C17.7769 7.3205 17.008 5.68139 15.6625 4.33268C14.317 2.98394 12.6795 2.21663 10.75 2.03075V9.25ZM9.25 17.9692V2.03075C7.18845 2.21663 5.46473 3.07016 4.07883 4.59133C2.69293 6.11248 1.99998 7.91536 1.99998 9.99998C1.99998 12.0846 2.69293 13.8875 4.07883 15.4086C5.46473 16.9298 7.18845 17.7833 9.25 17.9692ZM10.75 17.9692C12.6795 17.7936 14.3195 17.0288 15.6702 15.675C17.0208 14.3211 17.7872 12.6795 17.9692 10.75H10.75V17.9692ZM10.0016 19.5C8.68772 19.5 7.45268 19.2506 6.29655 18.752C5.1404 18.2533 4.13472 17.5765 3.2795 16.7217C2.42427 15.8669 1.74721 14.8616 1.24833 13.706C0.749442 12.5504 0.5 11.3156 0.5 10.0017C0.5 8.68772 0.749334 7.45268 1.248 6.29655C1.74667 5.1404 2.42342 4.13472 3.27825 3.2795C4.1331 2.42427 5.13834 1.74721 6.29398 1.24833C7.44959 0.749443 8.68437 0.5 9.9983 0.5C11.3122 0.5 12.5445 0.749684 13.6952 1.24905C14.8458 1.7484 15.8512 2.4282 16.7115 3.28845C17.5718 4.14872 18.2516 5.15378 18.7509 6.30363C19.2503 7.45349 19.5 8.68663 19.5 10.003C19.5 11.3036 19.2506 12.5313 18.752 13.6861C18.2533 14.841 17.5765 15.8495 16.7217 16.7117C15.8669 17.5739 14.8616 18.2541 13.706 18.7525C12.5504 19.2508 11.3156 19.5 10.0016 19.5Z',
        },
      ],
    },
    paretoChart: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M10.1936 20V12.2593H13.8064V20H10.1936ZM4 20V9H7.61286V20H4ZM16.3871 20V14.7037H20V20H16.3871Z',
        },
        {
          d: 'M5.5 8V6.5L12 3.5L18.5 1.5V3L12 5L5.5 8Z',
        },
      ],
    },
    heatmap: {
      viewBox: '0 -4 24 24',
      paths: [
        {
          d: 'M0 2V0H3V2H0ZM5 2V0H8V2H5ZM10 2V0H13V2H10ZM15 2V0H18V2H15Z',
        },
        {
          d: 'M0 10V8H3V10H0ZM0 6V4H3V6H0ZM5 10V8H8V10H5ZM5 6V4H8V6H5ZM10 10V8H13V10H10ZM10 6V4H13V6H10ZM15 10V8H18V10H15ZM15 6V4H18V6H15Z',
        },
        {
          d: 'M0 18V16H3V18H0ZM0 14V12H3V14H0ZM5 18V16H8V18H5ZM5 14V12H8V14H5ZM10 18V16H13V18H10ZM10 14V12H13V14H10ZM15 18V16H18V18H15ZM15 14V12H18V14H15Z',
        },
      ],
    },
    maximise: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M3 10H5V5H10V3H3V10ZM19 19H14V21H21V14H19V19Z',
        },
      ],
    },
    minimise: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M3 10V8H8V3H10V10H3ZM14 14V21H16V16H21V14H14Z',
        },
      ],
    },
    addToDashboard: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM16 13H18V16H21V18H18V21H16V18H13V16H16V13ZM15 5V9H19V5H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z',
        },
      ],
    },
    datasourceComparison: {
      viewBox: '0 -4 24 24',
      paths: [
        {
          d: 'M13 18V15H9V5H7V8H0V0H7V3H13V0H20V8H13V5H11V13H13V10H20V18H13ZM15 6H18V2H15V6ZM15 16H18V12H15V16ZM2 6H5V2H2V6Z',
        },
      ],
    },
    dateRangeComparison: {
      viewBox: '0 -2 24 24',
      paths: [
        {
          d: 'M6 14.5C5.3 14.5 4.70833 14.2583 4.225 13.775C3.74167 13.2917 3.5 12.7 3.5 12C3.5 11.3 3.74167 10.7083 4.225 10.225C4.70833 9.74167 5.3 9.5 6 9.5C6.7 9.5 7.29167 9.74167 7.775 10.225C8.25833 10.7083 8.5 11.3 8.5 12C8.5 12.7 8.25833 13.2917 7.775 13.775C7.29167 14.2583 6.7 14.5 6 14.5ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6Z',
        },
      ],
    },
    consumption: {
      viewBox: '0 0 24 24',
      paths: [
        {
          d: 'M1.4 12L0 10.6L7.4 3.15L11.4 7.15L16.6 2H14V0H20V6H18V3.4L11.4 10L7.4 6L1.4 12Z',
        },
      ],
    },
    alertEnabled: {
      viewBox: '0 -960 960 960',
      paths: [
        {
          d: 'M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z',
        },
      ],
    },
    alertDisabled: {
      viewBox: '0 -960 960 960',
      paths: [
        {
          d: 'M160-200v-80h80v-280q0-33 8.5-65t25.5-61l60 60q-7 16-10.5 32.5T320-560v280h248L56-792l56-56 736 736-56 56-146-144H160Zm560-154-80-80v-126q0-66-47-113t-113-47q-26 0-50 8t-44 24l-58-58q20-16 43-28t49-18v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v206Zm-276-50Zm36 324q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Zm33-481Z',
        },
      ],
    },
    addDataSource: {
      viewBox: '0 -4 24 24',
      paths: [
        {
          d: 'M8.30765 16.0768H5.53845C4.28282 16.0768 3.2125 15.6344 2.3275 14.7495C1.4425 13.8646 1 12.7945 1 11.539C1 10.2835 1.4425 9.21312 2.3275 8.32787C3.2125 7.44262 4.28282 7 5.53845 7H8.30765V8.49995H5.53845C4.6987 8.49995 3.98235 8.79643 3.3894 9.38938C2.79645 9.98233 2.49998 10.6987 2.49998 11.5384C2.49998 12.3782 2.79645 13.0945 3.3894 13.6875C3.98235 14.2804 4.6987 14.5769 5.53845 14.5769H8.30765V16.0768ZM6.75 12.2884V10.7885H12.25V12.2884H6.75ZM10.6923 16.0768V14.5769H13.4615C14.3013 14.5769 15.0176 14.2804 15.6106 13.6875C16.2035 13.0945 16.5 12.3782 16.5 11.5384C16.5 10.6987 16.2035 9.98233 15.6106 9.38938C15.0176 8.79643 14.3013 8.49995 13.4615 8.49995H10.6923V7H13.4615C14.7171 7 15.7875 7.44244 16.6725 8.32733C17.5575 9.21221 18 10.2824 18 11.5379C18 12.7934 17.5575 13.8637 16.6725 14.749C15.7875 15.6342 14.7171 16.0768 13.4615 16.0768H10.6923Z',
        },
        {
          d: 'M19 1H17.5V4H14.5V5.5H17.5V8.5H19V5.5H22V4H19V1Z',
        },
      ],
    },
    aggregatedMetric: {
      viewBox: '6 6 24 24',
      paths: [
        {
          d: 'M17.2222 18H18.7778V12H17.2222V18ZM11 18H12.5556V12H11V18ZM23.4444 18H25V12H23.4444V18Z',
        },
        {
          d: 'M15.6667 18H14.1111V9H15.6667V18Z',
        },
        {
          d: 'M20.3333 18H21.8889V9H20.3333V18Z',
        },
        {
          d: 'M13.5 27L13.5 25.5L12 25.5L12 27L13.5 27Z',
        },
        {
          d: 'M13.5 28.5L13.5 27L12 27L12 28.5L13.5 28.5Z',
        },
        {
          d: 'M13.5 25.5L13.5 24L12 24L12 25.5L13.5 25.5Z',
        },
        {
          d: 'M9.5 25.5L9.5 24L8 24L8 25.5L9.5 25.5Z',
        },
        {
          d: 'M9.5 24L9.5 22.5L8 22.5L8 24L9.5 24Z',
        },
        {
          d: 'M21.5 24.5L21.5 23L20 23L20 24.5L21.5 24.5Z',
        },
        {
          d: 'M21.5 26L21.5 24L20 24L20 26L21.5 26Z',
        },
        {
          d: 'M28 26.5L28 24L26.5 24L26.5 26.5L28 26.5Z',
        },
        {
          d: 'M28 24L28 22.5L26.5 22.5L26.5 24L28 24Z',
        },
        {
          d: 'M12.3709 19.4468L9.5 22.4633L9.5 22.4995L8 22.4995L8 22.1655C8 22.0747 8.01865 21.9888 8.04825 21.9082C8.05075 21.9014 8.05191 21.8945 8.0546 21.8878C8.0882 21.8038 8.1373 21.7284 8.19718 21.6626C8.20041 21.6591 8.2013 21.6544 8.20459 21.6509L11 18.6359L11 17.3086L12.5755 17.8435L12.5755 18.9321C12.5755 19.0184 12.5579 19.0998 12.5311 19.177C12.5282 19.1854 12.5266 19.1937 12.5233 19.202C12.4895 19.2893 12.4398 19.3678 12.3778 19.4357C12.3747 19.4391 12.374 19.4435 12.3709 19.4468Z',
        },
        {
          d: 'M14.1133 19.7033L14.1133 17.9185L15.6719 17.9185L15.6719 19.8566C15.6719 19.941 15.6548 20.0207 15.6291 20.0964C15.6259 20.1061 15.6239 20.1156 15.6202 20.1252C15.587 20.2113 15.5382 20.2887 15.4776 20.3561C15.4741 20.3601 15.4732 20.3654 15.4695 20.3693L13.5 23.5462L13.5 23.9995L12 23.9995L12 23.2495C12 23.1599 12.0184 23.0751 12.0473 22.9953C12.0501 22.9876 12.0514 22.9798 12.0544 22.9722C12.0871 22.8904 12.1347 22.8171 12.1924 22.7524C12.1966 22.7477 12.1978 22.7415 12.2022 22.7368L14.1133 19.7033Z',
        },
        {
          d: 'M17.2249 18.625L17.2249 17.9375L18.7813 17.3748L18.7813 18.2188L21.363 22.1904C21.363 22.1904 21.4922 22.3633 21.5 22.5L21.5 23L20 23L17.6055 19.2779C17.6055 19.2779 17.2249 18.8955 17.2249 18.625Z',
        },
        {
          d: 'M23.6291 19.4473L26.5 22.4638L26.5 22.5L28 22.5L28 22.166C28 22.0752 27.9814 21.9892 27.9518 21.9086C27.9493 21.9018 27.9481 21.895 27.9454 21.8883C27.9118 21.8043 27.8627 21.7289 27.8028 21.6631C27.7996 21.6596 27.7987 21.6549 27.7954 21.6514L25 18.6364L25 17.3091L23.4246 17.844L23.4246 18.9326C23.4246 19.0188 23.4421 19.1003 23.4689 19.1774C23.4718 19.1859 23.4734 19.1941 23.4767 19.2025C23.5105 19.2898 23.5602 19.3683 23.6222 19.4362C23.6253 19.4396 23.626 19.444 23.6291 19.4473Z',
        },
        {
          d: 'M21.8867 18.7038L21.8867 16.9189L20.3281 16.9189L20.3281 18.8571C20.3281 18.9415 20.3452 19.0212 20.3709 19.0969C20.3741 19.1066 20.3761 19.1161 20.3798 19.1257C20.413 19.2118 20.4618 19.2892 20.5224 19.3566C20.5259 19.3606 20.5268 19.3658 20.5305 19.3698L23.5 23.2971L23.5 23.7505L25 23.7505L25 23.0005C25 22.9108 24.9816 22.826 24.9527 22.7463C24.95 22.7386 24.9486 22.7308 24.9456 22.7231C24.9129 22.6414 24.8653 22.568 24.8076 22.5034C24.8034 22.4986 24.8022 22.4925 24.7979 22.4878L21.8867 18.7038Z',
        },
        {
          d: 'M25 24.5L25 23.5L23.5 23.5L23.5 24.5L25 24.5Z',
        },
      ],
    },

    //
  }

  constructor(
    public tracing: TracingService,
    public hyper: HyperService
  ) {}

  ngOnInit() {
    if (this.hyper.isDotstring(this.color)) {
      const parsed = this.hyper.newParse(this.color)
      this.color = parsed.value
    }
    if (this.hyper.isDotstring(this.name)) {
      const parsed = this.hyper.newParse(this.name)
      this.name = parsed.value
    }
  }
}
